/* eslint-disable no-irregular-whitespace */
import { createGlobalStyle } from 'styled-components';
import {
  IC_CALENDAR,
  IC_CALL,
  IC_CARD_WORLD,
  IC_CHECKBOX_CHECKED_GREEN,
  IC_GREEN_RADIO_CHECKED,
  IC_RADIO_CHECKED,
  IC_RADIO_CHECKED_GREEN,
  IC_INCOMPLETE,
  IC_LOCATION_BLACK,
  IC_LOCATION_GREEN,
  IC_MODAL_CLOSE_GREY,
  IC_PENDING,
  IC_PENDING_RED,
  IC_RADIO,
  IC_RIGHT_GREEN,
  IC_SEARCH,
  IC_VERIFIED,
  LEGENDS_BG,
} from '../Assets/images';

export default createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    outline: none;
  }

  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {  
    scroll-behavior: auto !important;
  }

  body {
    font-family: 'Mulish', 'Arial', Segoe UI, helvetica, verdana, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.text.dark};
    background: ${(props) => props.theme.sectionBox.bodyBg};
  }

  .noDesktop {
    display: none !important;
  }

  .font-semi{
    font-weight: 600;
  }

  .font-bold{
    font-weight: 700;
  }

  .pageContent {
    width: 100%;
    padding-top: ${(props) => (props?.isNotSafari ? '209px' : '156px')};
    padding-bottom:40px;

    &.bg-grey{
      background-color:  ${(props) => props.theme.sectionBox.bodyBg};
    }
    &.no-scroll{
      max-height:100vh;
      overflow:hidden;
    }
  }

  input {
    &::-webkit-placeholder,
    &::placeholder {
      color: ${(props) => props.theme.text.medium};
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    margin: 0;
  }

  .form-control:disabled{
    background-color: ${(props) => props.theme.color.white};
    cursor: not-allowed;
  }

  .container {
    max-width: 1112px;
  }

  .checkout {
    display:none;
  }

  .okay-cta {
    color:${(props) => props?.theme?.green?.dark};
    font-size: 15px;
    font-weight: 700;
    padding: 8px 0 0 0;
    cursor: pointer;
  }

  .recordDetailsWrapper { 
     overflow-y: hidden !important;
    .modal-dialog {
      .modal-content{
        .modal-body {
          .record-wrapper {
            padding: 24px;
            margin-bottom: 25px;
            .vitalsSign{
              display: flex;
              .sign{
                border-bottom: 1px solid ${(props) => props?.theme?.color?.border};
                .signs{
                  border-left: 1px solid ${(props) => props?.theme?.color?.border};
                  color: ${(props) => props?.theme?.royalBlue?.darkGrey};
                  border-bottom: 0px;
                  margin-top: 19px;
                  font-size: 14px;
                  line-height: 18px;
                  height: 25px;
                  padding-left: 10px;
                  text-align: center;
                  width: 32px;
                }
              }
            }
      
            .bloodPressure{
              display: flex;
              flex-direction: column;
              .vitalsSign{
                display: flex;
                .sign{
                  border-bottom: 1px solid ${(props) => props?.theme?.color?.border};
                  .signs{
                    border-left: 1px solid ${(props) => props?.theme?.color?.border};
                    color: ${(props) => props?.theme?.royalBlue?.darkGrey};
                    border-bottom: 0px;
                    margin-top: 19px;
                    font-size: 14px;
                    line-height: 18px;
                    height: 25px;
                    padding-left: 10px;
                    text-align: center;
                    .diastolic{
                      width: 60px;
                    }
                  }
                }
              }
              .diagonal_line{
                border-left: 1px solid ${(props) => props?.theme?.blue?.grey};
                width: 5px;
                height: 33px;
                margin:6px 0px 0px 3px;
                padding: 0px;
                transform: rotate(18deg);
              }
            }
      
            .vitalSign{
              .inputField{
                padding-bottom: 20px !important;
                color: black;
                &:focus-visible {
                  border-color:${(props) => props?.theme?.color?.borderLight} !important;
                  outline: 0;
                  -webkit-box-shadow: none;
                  box-shadow: none;
                }
              }
            }
      
            h2 {
              font-size: 13px;
              font-weight: 600;
              line-height: 16px;
              color: ${(props) => props?.theme?.text?.medium};
              margin-bottom:0px;
      
              span {
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: ${(props) => props?.theme?.text?.medium};
              }
            }
           }
            .header {
              font-weight:500;
              font-size: 16px;
              line-height: 20px;
              color: ${(props) => props.theme.text.dark};
      
              span {
                font-weight: 600;
                font-size: 14px;
                line-height: 18px;
                color: ${(props) => props.theme.text.medium};
              }
            }
      
            .form-label {
              font-weight: 600;
              font-size: 17px;
              line-height: 21px;
              color: ${(props) => props?.theme?.text?.medium};
              margin: 0px;
            }
      
            .form-text {
              display: block;
              font-weight: 600;
              font-size: 14px;
              line-height: 18px;
              color: ${(props) => props.theme.text.medium};
              margin: 0px 0px 9px 0px;
            }
      
            h2 {
              font-weight: 600;
              font-size: 13px;
              line-height: 16px;
              color: ${(props) => props?.theme?.text?.medium};
              margin-bottom: 11px;
      
              span{
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: ${(props) => props.theme.text.medium};
              }
            }
      
            .invalid-feedback {
              font-size: 16px;
              font-weight: 600;
              padding-left: 25px;
              background: url(${IC_PENDING_RED.src}) no-repeat 0 4px / 18px;
              color: ${(props) => props.theme.verification.red.main};
            }
      
            .group-wrapper {
              position: relative;
              width: 178px;
              margin: 0px;
      
              .element-wrapper {
                background: ${(props) => props.theme.color.white};
                border: 1px solid ${(props) => props.theme.color.lightGray};
                box-sizing: border-box;
                border-radius: 8px;
                width: 178px;
                height: 56px;
      
                input[type='text'] {
                  border: 0px solid ${(props) => props.theme.color.white};
                  width: 108px;
                  height: 56px;
                  background-color: transparent;
      
                  &:focus {
                    box-shadow: none;
                  }
                }
              }
              .element-overlay {
                position: absolute;
                width: 70px;
                height: 56px;
                right: 0px;
                top: 0px;
                background: ${(props) => props.theme.color.divider};
                border: 1px solid ${(props) => props.theme.color.lightGray};
                box-sizing: border-box;
                border-radius: 0px 8px 8px 0px;
                font-weight: 600;
                font-size: 16px;
                line-height: 56px;
                text-align: center;
                color: ${(props) => props.theme.text.medium};
              }
      
              &.is-invalid {
                .element-wrapper {
                  border-color: ${(props) => props.theme.verification.red.main};
                }
                .element-overlay {
                  border-color: ${(props) => props.theme.verification.red.main};
                  border-left: 1px solid ${(props) => props.theme.color.lightGray};
                }
              }
              
              .divider {
                position: absolute;
                right: -18px;
                top: 15px;
              }
            }
          }
          .sm_waitingrm_wrapper {
            padding: 0px 20px 20px 20px;
            margin-bottom: 30px;
      
            .vitalsDisclaimer {
              display: flex;
              flex-direction: row;
              padding: 12px 8px;
              margin: 12px 0px 0px 0px;
              height: auto;
              background-color: ${(props) => props.theme.blue.iconBg};
              border-radius: 8px;
      
              .vitalsDisclaimerText {
                margin-left: 8px;
                font-size: 14px;
                line-height: 18px;
                font-weight: 400;
                color: ${(props) => props.theme.text.medium};
              }
            }
      
            h2 {
              font-size: 13px;
              font-weight: 600;
              line-height: 16px;
              color: ${(props) => props?.theme?.text?.medium};
              margin-bottom:0px;
      
              span {
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: ${(props) => props?.theme?.text?.medium};
              }
            }
      
            .vitalsSign{
              display: flex;
              margin-top: 20px;
              .sign{
                border-bottom: 1px solid ${(props) => props?.theme?.color?.border};
                .signs{
                  border-left: 1px solid ${(props) => props?.theme?.color?.border};
                  color: ${(props) => props?.theme?.royalBlue?.darkGrey};
                  border-bottom: 0px;
                  margin-top: 19px;
                  font-size: 14px;
                  line-height: 18px;
                  height: 25px;
                  padding-left: 10px;
                  text-align: center;
                  width: 32px;
                }
              }
            }
      
            .bloodPressure{
              display: flex;
              flex-direction: column;
              .blood-wrapper{
                width: 490px;
              }
              .vitalsSign{
                display: flex;
                .sign{
                  border-bottom: 1px solid ${(props) => props?.theme?.color?.border};
                  .signs{
                    border-left: 1px solid ${(props) => props?.theme?.color?.border};
                    color: ${(props) => props?.theme?.royalBlue?.darkGrey};
                    border-bottom: 0px;
                    margin-top: 19px;
                    font-size: 14px;
                    line-height: 18px;
                    height: 25px;
                    padding-left: 10px;
                    text-align: center;
                    .diastolic{
                      width: 60px;
                    }
                  }
                }
              }
            
              .diagonal_line{
                border-left: 1px solid ${(props) => props?.theme?.blue?.grey};
                width: 5px;
                height: 33px;
                margin:6px 0px 0px 3px;
                padding: 0px;
                transform: rotate(18deg);
              }
            }
      
            .vitalSign{
              .inputField{
                padding-bottom: 20px !important;
                color: black;
                &:focus-visible {
                  border-color:${(props) => props?.theme?.color?.borderLight} !important;
                  outline: 0;
                  -webkit-box-shadow: none;
                  box-shadow: none;
                }
              }
            } 
           }
      
            .header {
              font-weight:600;
              font-size: 14px;
              line-height: 20px;
              color: ${(props) => props.theme.text.dark};
      
              span {
                font-weight: 600;
                font-size: 14px;
                line-height: 18px;
                color: ${(props) => props.theme.text.medium};
              }
            }
      
            .form-label {
              font-weight: 600;
              font-size: 17px;
              line-height: 21px;
              color: ${(props) => props.theme.text.dark};
              margin: 0px;
            }
      
            .form-text {
              display: block;
              font-weight: 600;
              font-size: 14px;
              line-height: 18px;
              color: ${(props) => props.theme.text.medium} !important;
              margin: 0px 0px 9px 0px;
            }
      
            h2 {
              font-weight: 700;
              font-size: 17px;
              line-height: 21px;
              color: ${(props) => props?.theme?.text?.dark};
              margin-bottom: 8px;
            }
      
            .sm_weight {
              margin-top: 24px !important;
            }
      
            .border-bottom{
              border-bottom: none !important;
            }
      
            .invalid-feedback {
              font-size: 16px;
              font-weight: 600;
              padding-left: 25px;
              background: url(${IC_PENDING_RED.src}) no-repeat 0 4px / 18px;
              color: ${(props) => props.theme.verification.red.main};
            }
      
            .group-wrapper {
              position: relative;
              width: 100%;
              margin: 0px;
      
              .element-wrapper {
                background: ${(props) => props.theme.color.white};
                border: 1px solid ${(props) => props.theme.color.lightGray};
                box-sizing: border-box;
                border-radius: 8px;
                width: 100%;
                height: 56px;
      
                input[type='text'] {
                  border: 0px solid ${(props) => props.theme.color.white};
                  width: 100%;
                  height: 56px;
                  background-color: transparent;
      
                  &:focus {
                    box-shadow: none;
                  }
                }
              }
              .element-overlay {
                position: absolute;
                width: 70px;
                height: 56px;
                right: 0px;
                top: 0px;
                background: ${(props) => props.theme.color.divider};
                border: 1px solid ${(props) => props.theme.color.lightGray};
                box-sizing: border-box;
                border-radius: 0px 8px 8px 0px;
                font-weight: 600;
                font-size: 16px;
                line-height: 56px;
                text-align: center;
                color: ${(props) => props.theme.text.medium};
              }
      
              &.is-invalid {
                .element-wrapper {
                  border-color: ${(props) => props.theme.verification.red.main};
                }
                .element-overlay {
                  border-color: ${(props) => props.theme.verification.red.main};
                  border-left: 1px solid ${(props) => props.theme.color.lightGray};
                }
              }
              
              .divider {
                display: none;
              }
              
            }
      
            .sm_enter_text{
              padding: 0px;
              gap: 10px;
              border-radius: 0px;
              border: none !important;
              border-bottom: 1px solid ${(props) => props?.theme?.blue?.grey} !important; 
              .form-label{
                padding-bottom: 0 !important;
              }
              input[type='text'] {
                height: 30px !important;
                padding: 0 !important;
                border-bottom: none !important;
              }
            }
          }
        }
      }
    }
  }

  .checkbox-footer .rightBarDialogStyled .modal-content {
    .modal-footer {
      height: 140px !important;

      .checkout-box-container-vital {
        display: flex;
        flex-direction: column;

        .checkbox-container-vital {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 10px;
          flex-wrap: nowrap;

          .checkbox-vital {
            width: 30px;
            height: 30px;
            border-radius: 8px;
            margin-bottom: 10px;
            padding: 12px 10px;
            border: 1px solid ${(props) => props?.theme?.color?.borderLight};
            color: ${(props) => props?.theme?.text?.dark};
            font-size: 16px;
            line-height: 16px;
            font-family: Mulish;
            font-size: 14px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .checkbox-span {
            color: ${(props) => props?.theme?.text?.medium};
          }

          .link-consent {
            border: none;
            color: ${(props) => props?.theme?.blue?.dark};
            background-color: ${(props) => props?.theme?.color?.white};
            text-decoration: underline;
          }
        }

        .bookingBtn-checkbox{
          margin: 10px 0px 10px 0px;
        }
      }
    }
  }

  .addFamilyModal { 
    .modal-dialog {
      .modal-content{
        .modal-header{
          .modal-title{
            display: flex;
            .btn{
              margin-right: 7px;
              margin-top: 2px;
            }
          }
        }
        .modal-body {
          .mobile-profile-pic {
            padding: 0px 24px;
          }
        }
      }
    }
  }
  
  .underReviewWrapper { 
    .modal-dialog {
      .modal-content{
        .modal-body {
          .under-review-profile{
            .card-space-holder {
              .card_wrapper {
                min-height: 510px;
                background: linear-gradient(rgb(241, 246, 251) 0px, rgb(255, 255, 255) 50px);
                border-radius: 0px;
                padding: 0;
                padding-top: 30px;
          
                .subtitle {
                  font-size: 16px;
                  line-height: 20px;
                  font-weight: 400;
                  padding: 7px 20px;
                }
                .btnContainer{
                  display: flex;
                  padding: 10px 55px;
                  @media (max-width: 450px) {
                    padding: 10px 38px;
                  }

                  .call{
                    display: flex;
                    flex-direction: colum;
                    align-items: center;
                    gap: 5px;
                  }
                }
              }
            }
            .family-members-list-wrapper {
              background: ${(props) => props?.theme?.sectionBox?.bodyBg};
              padding-right: 0px;
              padding-top: 20px;
              display: flex;
              border:0;
              .member-detail{
                margin-left:20px;
                .name{
                  text-align: start;
                }
              }
            }
          }
        }
      }
    }
  }

  .video-player { 
    .modal-dialog {
      .modal-content, .modal-header {
        padding: 0 !important;
        background: transparent !important;
        border: none !important;
        .modal-body {
          padding: 24px 0;
          iframe {
            padding: 0;
          }
        }
      }
    }
  }
  .btn {
    padding: 16px 20px;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    border-radius: 8px;
    margin: 0 20px 0 0;
    &.homecare{
      line-height : 20px;
      font-weight : 600;
      font-size : 17px;
      color : ${(props) => props?.theme?.blue?.royal};
    }
    &.btn-epharmacy {
      border-radius: 8px;
      height: 52px;
      width: 100%;
      border: 1px solid ${(props) => props.theme.green.dark};
      background-color: ${(props) => props.theme.green.dark};
      color: ${(props) => props.theme.color.white};
      font-size: 17px;
      line-height: 17px;
      font-weight: 700;
      &:hover {
        background: ${(props) => props?.theme?.color?.white}90;
        border-color: ${(props) => props.theme.color.border};
        color: ${(props) => props.theme.green.dark};
      }
    }
    &.disabled,
    &:disabled {
      background: ${(props) => props?.theme?.blue?.grey}70 !important;
      border-color: ${(props) => props.theme.blue.grey}10 !important;
      color: ${(props) => props.theme.blue.grey} !important;
    }

    &.btn-sm {
      padding: 10px 20px;
    }
    &.btn-epharmacy {
      border-radius: 8px;
      height: 52px;
      width: 100%;
      border: 1px solid ${(props) => props.theme.green.dark};
      background-color: ${(props) => props.theme.green.dark};
      color: ${(props) => props.theme.color.white};
      font-size: 17px;
      line-height: 21px;
      font-weight: 700;
    }
    &.dropdown-toggle {
      margin: 0;

      &.btn-primary {
        &:hover {
          background: ${(props) => props?.theme?.color?.white}90;
          border-color: ${(props) => props.theme.color.border};
        }
      }
    }

    &.btn-primary {
      color: ${(props) => props?.theme?.color?.white};
      font-weight: 700;
      background: ${(props) => props?.theme?.blue?.dark};
      border-color: ${(props) => props?.theme?.blue?.dark};
      
      &:hover {
        background: ${(props) => props?.theme?.blue?.light}90;
        border-color: ${(props) => props?.theme?.blue?.light}30;
      }
      
      &:focus {
        border-color: ${(props) => props.theme.color.border};
        box-shadow: 0 0 0;
      }

      &.epharmacy {
        color: ${(props) => props?.theme?.color?.white};
        background: ${(props) => props?.theme?.green?.dark};
        border-color: ${(props) => props?.theme?.green?.dark};
        
        &:hover {
          color: ${(props) => props?.theme?.color?.white};
          background: ${(props) => props?.theme?.green?.light};
          border-color: ${(props) => props?.theme?.green?.light};
        }
      }
      &.homecare{
        color: ${(props) => props?.theme?.royalBlue?.dark} !important;
        background: ${(props) => props?.theme?.royalBlue?.off} !important;
        margin-top : 20px;
        border: none !important;
        margin: 20px 0 0 0;
        font-size :16px;
      }
      &.consentForm{
        display : flex;
        flex-direction : row;
        justify-content : space-between;
      }
    }

    &.btn-secondary {
      color: ${(props) => props?.theme?.blue?.dark};
      background: ${(props) => props?.theme?.blue?.off};
      border-color: ${(props) => props?.theme?.blue?.off};
      
      &:hover {
        color: ${(props) => props?.theme?.color?.white};
        background: ${(props) => props?.theme?.blue?.light};
        border-color: ${(props) => props?.theme?.blue?.light};
      }

      &.epharmacy {
        color: ${(props) => props?.theme?.green?.dark};
        background: ${(props) => props?.theme?.green?.extraLight};
        border-color: ${(props) => props?.theme?.green?.extraLight};
        
        &:hover {
          color: ${(props) => props?.theme?.green?.dark};
          background: ${(props) => props?.theme?.green?.medium};
          border-color: ${(props) => props?.theme?.green?.medium};
        }
      }
      &.homecare {
        background: ${(props) => props?.theme?.blue?.royal} !important;
        color: ${(props) => props?.theme?.color?.white} !important;
        margin: 0;
        font-size : 16px;
        &:hover {
          color: ${(props) => props?.theme?.color?.white} !important;
          background: ${(props) => props?.theme?.royalBlue?.dark}; 
          border-color: ${(props) => props?.theme?.royalBlue?.dark};
        }
      }
    }

    &.btn-danger {
      color: ${(props) => props?.theme?.color?.white};
      font-weight: 700;
      background: ${(props) => props?.theme?.color?.red};
      border-color: ${(props) => props?.theme?.color?.red};
      &:hover {
        background: ${(props) => props?.theme?.color?.red};
        border-color: ${(props) => props?.theme?.color?.red};
      }
    }

    &.btn-success {
      color: ${(props) => props?.theme?.color?.white};
      font-weight: 700;
      background: ${(props) => props?.theme?.green?.dark};
      border-color: ${(props) => props?.theme?.green?.dark};
      &:hover {
        background: ${(props) => props?.theme?.green?.light};
        border-color: ${(props) => props?.theme?.green?.light};
      }

      &.homecare {
        background :  ${(props) => props?.theme?.blue?.royal};
        border-color: ${(props) => props?.theme?.blue?.royal};
        &:hover {
        background: ${(props) => props?.theme?.royalBlue?.dark};
        border-color: ${(props) => props?.theme?.royalBlue?.dark};
        }
      }
    }

    &:focus {
      box-shadow: 0 0 0;
    }

    &.btn-outline-primary {
      color: ${(props) => props?.theme?.blue?.dark};
      border-color: ${(props) => props?.theme?.blue?.dark};

      &:hover {
        color: ${(props) => props?.theme?.color?.white};
        background: ${(props) => props?.theme?.blue?.dark};
      }
      &.homecare{
        color: ${(props) => props?.theme?.royalBlue?.dark};
        border-color: ${(props) => props?.theme?.royalBlue?.dark};
        &:hover {
          color: ${(props) => props?.theme?.royalBlue?.dark};
          background: ${(props) => props?.theme?.color?.white};

        }
      }
    }

    &.btn-outline-danger {
      display: flex;
      color: ${(props) => props?.theme?.orange?.dark};
      border-color: ${(props) => props?.theme?.colors?.secondary?.orange?.['900']};
      &:hover {
        color: ${(props) => props?.theme?.color?.white};
        background-color: ${(props) => props?.theme?.colors?.secondary?.orange?.['900']} !important; 
      }
       
       &.disabled,
       &:disabled {
         background-color: ${(props) => props?.theme?.orange?.off} !important;
         color: ${(props) => props?.theme?.orange?.dark} !important;
       }
    }

    &.btn-outline-success {
      color: ${(props) => props?.theme?.green?.dark};
      border-color: ${(props) => props?.theme?.green?.dark};

      &:hover {
        color: ${(props) => props?.theme?.color?.white};
        background: ${(props) => props?.theme?.green?.dark};
      }

      &.homecare {
        color: ${(props) => props?.theme?.blue?.royal};
        border-color: ${(props) => props?.theme?.blue?.royal};

        &:hover {
          color: ${(props) => props?.theme?.color?.white};
          background: ${(props) => props?.theme?.blue?.royal};
        }

        &:focus-visible {
          color: ${(props) => props?.theme?.color?.white};
          background: ${(props) => props?.theme?.text?.lightBlue};
          border-color: ${(props) => props?.theme?.text?.lightBlue};
          outline: 0;
          -webkit-box-shadow: none;
          box-shadow: none;
        }
        &:first-child:active{
          color: ${(props) => props?.theme?.color?.white};
          background: ${(props) => props?.theme?.text?.lightBlue};
          border-color: ${(props) => props?.theme?.text?.lightBlue};
          outline: 0;
          -webkit-box-shadow: none;
          box-shadow: none;
        }
      }
    }

  }

  .modalBackDropStyled {
    z-index: 1101;
    height: 100%;
    width: 100%;
  }
  
  .modal {
    z-index: 1201;
    overflow-y: hidden;
    padding-right: 0 !important; 

    &.complete_modal{
      .modal-content{ 
        .modal-footer{
          padding-top:0 !important;
        }
      }      
    }

    &.doctorCardInfo{
      .modal-dialog{
        .modal-content{
        .modal_wrapper{
          .modalWrapperTop{
            background: url(${LEGENDS_BG.src});

            .modalHeaderWrapper{
              display: flex;
              flex-direction: row;
              margin-left: 86px;
              gap: 70px;
              padding: 0px 5px 0px 5px;
              .modalHeader{
                  color:  ${(props) => props?.theme?.text?.dark};
                  text-align: center;
                  font-size: 22px;
                  font-weight: 700;
                  line-height: 28px;
              }
            }
            .modalDescription{
              color: ${(props) => props?.theme?.text?.medium};
              font-size: 14px;
              font-weight: 500;
              text-align: center;
              padding: 0px 22px;
              margin-top: 10px;
            }
          }
          .modalWrapperBelow{
            .doctorIconWrapper{
              background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23E9C755' stroke-width='5' stroke-dasharray='6%2c 14' stroke-dashoffset='30' stroke-linecap='square'/%3e%3c/svg%3e");

              display: flex;
              padding: 20px 64px 20px 16px;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              gap: 8px;
              margin-top: 25px;
              border-radius: 12px;

              .doctorIcon{
                display: inline-flex;
                padding: 2px 4px 2px 0px;
                justify-content: center;
                align-items: center;
                gap: 4.021px;
                border-radius: 4px;
                height: 32px;
              }
              .doctorIconDescription{
                color: ${(props) => props?.theme?.color?.icon};
                font-size: 14px;
                font-weight: 600; 
                line-height: 19px;
                width: auto;
                text-align: left;
              }
              .blueText{
                color:  ${(props) => props?.theme?.blue?.dark};
              }
            }
          }
        }
      }
      }
      @media (max-width: 750px) {
        .modalHeaderWrapper{
          gap: 0px !important;
          margin-left: 0px !important;
          justify-content: center !important;
        }
        .modalDescription{
          padding: 0px !important;
        }
        .closeBtn{
          margin-left:16px !important;
        }
      }
      @media (min-width: 319px) and (max-width: 373px) {
        .closeBtn{
          margin-left: 3px !important;
        }
      }
    }
    @media (min-width: 360px) and (max-width: 409px) {
      &.doctorCardInfo{
        .modal-dialog{
          width: 87%;
        }
      }
    }
    @media (min-width: 410px) and (max-width: 425px) {
      &.doctorCardInfo{
        .modal-dialog{
          width: 95%;
        }
      }
    }

    &.referral_modal{
      .modal-content{ 
        .modal-footer{
          padding-top:0 !important;

          .btn-primary{
            margin-top:0 !important;
          }

          .btn-link{
            padding-top:0 !important;
            padding-bottom:3px !important;
            color: ${(props) => props.theme.blue.dark};
          }
        }
      }      
    }

      &.custom-size-md {
        .modal-dialog {
          width: 468px;
          max-width: calc(100% - 1rem);
        }
          .modal-content {
              .modal-body {
                padding: 20px 24px 0 !important;
              }
            }
        }
    .modalDialogStyled {
      .modal-content {
        .modal-header {
          padding: 25px 16px;
          border-bottom-color: ${(props) => props.theme.color.borderLight};
          .modal-title {
            width: 100%;
            font-size: 22px;
            font-weight: 700;
            text-align: center;

            &.text-left {
              text-align: left;
            }
          }
        }

        .modal-body {
          font-size: 17px;
          padding: 24px;
          white-space: pre-line;

          > div {
            
            a {
              color: ${(props) => props?.theme?.text?.darkest};
            }
          }
        }

        .modal-footer {
          padding: 25px 16px;
          border-top: 0;
          &.homecare{
            padding-top : 5px !important;
          }
          &.homecareRx{
            padding: 10px 16px 28px;
          }
          &.homecareAddress{
            padding: 0 16px 28px;
          }
          .btn {
            &:last-child {
              margin-right: 0;
            }
          }
          .btn.homecareUploadRx:first-child{
            margin: 0 0 0 10px !important;
          }
          .btn.homecareUploadRx:last-child{
            margin: 0 10px 0 0 !important;
          }
        }
      }
    }

    .rightBarDialogStyled {
      height: 100vh;
      margin: 0 0 0 auto;

      &.modal-md {
        max-width: 450px;
      }

      .modal-content {
        height: 100vh;
        border-radius: 0;
        border: 0;
        position: relative;

        .modal-header {
          &.bundleside{
            height:118px !important;
          }
          padding: 24px;
          border-bottom-color: ${(props) => props.theme.color.border};
          background-color: ${(props) => props.theme.color.white};
          position: sticky;
          top: 0;
          z-index: 1;
          height: 88px;
          .btn-close {
            position: relative;
            &:after{
              content: "";
              left: -22px;
              top: -31px;
              height: 96px;
              width: 1px;
              position: absolute;
            }
          }

          .modal-title {
            width: 80%;
            font-size: 20px;
            line-height: 25px;
            font-weight: 700;
            text-align: left;
            .sub-title {
              font-size: 14px !important;
              font-weight: 500 !important;
              line-height: 24px !important;
            }
            &.promotionCart {
              font-size:18px;
              .promotionCartcard{
                font-size:14px;
                font-weight: 500;
                color:${(props) => props.theme.text.medium};
              }
              .promotionCartca{
                font-size:12px;
                font-weight: 500;
                line-height: 15px;
                color:${(props) => props.theme.text.medium};
              }
            }
          }
        }

        .modal-body {
          font-size: 17px;
          padding: 0;
          bottom: 92px;
          overflow-x:scroll;
          scrollbar-width: thin;
          scrollbar-color: transparent transparent;
          &::-webkit-scrollbar {
              display: none;
              }
          &::-moz-scrollbar {
             display: none;
              }
          background: linear-gradient(to bottom, white, white 92%, #f0f6fb 100%);
          @media (max-width: 450px) {
            &.promotionCart {
              display: flex;
              justify-content:space-evenly;
            }
         }
         &.bundleOfferBody{
          .cardswrapper{
            padding-top: 38px;
              padding-left: 24px;
              padding-right: 24px;
            }
            .bundlecardgreen{
              .imageicon{
                margin-left: 353px;
                margin-top: -60px;
              }
              .title{
                margin-left: 17px;
                display: flex;
               flex-direction: column;
              }
              .ima{
                 display: flex;
              }
              border-radius: 8px;
              border: 1px solid var(--Colors-ePharmacy-Green-700, #388E3C);
              background: var(--Colors-ePharmacy-Green-ExtraLight, #F4FAF4);
              width: 403px !important;
              height: 80px;
              position: relative;
              padding-top: 16px;
              padding-left: 18px;
              margin-top: 16px;
              .headp-selected{
                font-size: 14px;
                color: var(--ePharmacy-Green-700, var(--Colors-ePharmacy-Green-700, #388E3C));
                font-weight: 700;
                .percentagegreen{
                  position: relative;
                  height: 28px;
                  background-color: ${(props) => props.theme.green.medium};
                  background: var(--Colors-ePharmacy-Green-Medium, #E0F1E1);
                  border-radius: 6px;
                  padding: 4px 8px;
                }
              }
              .subp-selected{
                font-size: 12px;
                margin-top: 5px;
                font-weight: 500;
                color: var(--Colors-Global-Colors-Icons-OuterSpace-800, #3D4954);


              }
            }
            .bundlecardgreen:hover{
              cursor: pointer;
            }
            .bundlecard:hover {
            cursor: pointer;
            }
            .bundlecard{
              .title{
                margin-left: 17px;
                display: flex;
                flex-direction: column;
                font-size: 22px;
               }
           .ima{
              display: flex;
              }
              border-radius: 8px;
              border: 1px solid var(--Colors-Global-Colors-Borders-DarkBlue-50, #E3E9EF);
              background: var(--Colors-Global-Colors-Typography-White, #FFF);
              width: 403px !important;
              height: 80px;
              padding-top: 16px;
              padding-left: 18px;
              margin-top: 11px;
              .headp{
                font-size: 14px;
                font-weight: 700;
                color: var(--Light_Theme-Main_Typography, var(--Colors-Global-Colors-Typography-DarkBlue-900, #031A32));
              }
              .subp{
                font-size: 12px;
                margin-top: 2px;
                font-weight: 500;
                color: var(--Colors-Global-Colors-Typography-DarkBlue-400, #78909C);
              }
         }
      }
          &.promotionCart {
            display: flex;
            flex-wrap: wrap;
            padding-left: 0;
            padding-bottom:10px;
          }
          &.promotionCartlen{
            display: flex;
            flex-wrap: wrap;
            height:90vh;
            padding-bottom:440px;
            padding-left: 0;
            position:relative;
            top:0px;
            flex: none;
          }
          &.fbtcartlen{
            display: flex;
            flex-wrap: wrap;
            height:77vh;
            padding-left: 0;
            position:relative;
            top:0px;
            flex: none;
          }
          .promotion{
            height:51px;
            padding:20px;
            width:100%;
            display:flex;
            align-items: center;
            background-color:${(props) => props.theme.yellow.off};;
            
            .promotionText{
              .custom-strong{
                text-shadow: 0.5px 0 #388e3c;
              }
              line-height:1.2;
              color:${(props) => props.theme.mandalay.dark};
              width:100%;
              padding: 0px 10px 0px 10px;
              font-size:14px;
              font-weight:700;
              padding-top:12px;
              padding-bottom:12px;
            }
          }
          .noActionRequired{
            height:51px;
            @media (max-width: 450px){
              width:100%;
            }
            padding:20px;
            display:flex;
            align-items: center;
            background-color:${(props) => props.theme.green.off};
            
            .promotionText{
              .custom-strong{
                text-shadow: 0.5px 0 #388e3c;
              }
              line-height:1.2;
              color:#388E3C;
              width:100%;
              padding: 0px 10px 0px 10px;
              font-size:14px;
              font-weight:700;
              padding-top:12px;
              padding-bottom:12px;
            }

          }

          &.fullHeight {
            bottom: 0;
          }
        }

        .modal-footer {
          background-color: ${(props) => props.theme.color.white};
          box-shadow: ${(props) => props.theme.rightSideBar.footerShadow};
          padding: 12px 16px;
          position: fixed;;
          bottom:0;
          width:450px !important;
          max-width:100%;
          z-index: 1;
          height: 92px;

          .add-new-address-container {
             text-align: left;
             margin-left: -20px;
             color: ${(props) => props?.theme?.colors?.primary?.blue["700"]}; 

             span {
              margin-left: 10px;
             }
          }

        }
        .btn-close{
          position: relative;
          margin-right:2px;
          background: transparent url(${IC_MODAL_CLOSE_GREY.src});
          background-repeat: no-repeat;
          background-position:center;
          background-size:16px;
          height:16px;
          width:16px;
          padding:10px;
          padding-left:2px;
          opacity:1;

          &:before {
            content:"";
            position: absolute;
            height:88px;
            width:1px;
            background-color: ${(props) => props.theme.color.divider};
            left:-30px;
            top:-26px;
            opacity:1;
          }
        }
        .form-label {
          font-weight: 600;
          font-size: 16px;
          line-height: 20px;
          padding-bottom: 7px;
          color: ${(props) => props?.theme?.text?.medium};
        }
        .grey-label{
          color: ${(props) => props.theme.text.medium};
          .radio-btn-wrapper{
            .form-check {
            .form-check-label {
              font-weight: 600;
               color: ${(props) => props.theme.text.medium};
            }
          }

          }
        }
          .form-check {
            .form-check-label {
              font-weight: 600;
            }
          }

      }
    
      .modal-body {
        position: fixed;
        right:0;
        top:88px;
        bottom:0;
        width:450px;
        max-width:100%;
        font-size: 17px;
        padding: 0;
        overflow:auto;
        background-color: ${(props) => props.theme.rightSideBar.bodyBg};
        &.whiteBg {background-color:${(props) => props.theme.color.white};}
      }
      .modal-footer {
        background-color:  ${(props) => props.theme.color.white};
        box-shadow: ${(props) => props.theme.rightSideBar.footerShadow};
        border-top-color: transparent;
        padding: 18px 16px;
        bottom:0;
        right:0;
        width:450px;
        max-width:100%;
        z-index:2;
        height:92px;
        position: fixed;
        width: 100%;
      }
    }
    &.epharmacy {
      .rightBarDialogStyled {
        .modal-content {
          .form-check {
            .form-check-label {
              font-weight: 600;
              color:${(props) => props.theme.text.medium};
            }
            .form-check-input[type="radio"] {
              &:checked {
                background: url(${IC_GREEN_RADIO_CHECKED.src}) no-repeat 50% 50%;
                + label {
                  color:  ${(props) => props.theme.green.dark};
                }
              }
            }
            .form-check-input[type="checkbox"] {
              &:checked {
                background: url(${IC_CHECKBOX_CHECKED_GREEN.src}) no-repeat 50% 50%;
              }
            }
          }
          .content {
            .addressList {
              .addressBox {
                cursor: pointer;
                .addressType {
                  color: ${(props) => props.theme.color.white};
                  background:  ${(props) => props.theme.green.dark};
                }
              }
              .actionButtons {
                .btn {
                  &.btn-primary {
                    color: ${(props) => props.theme.green.dark};
                    &:hover {
                      color: ${(props) => props.theme.color.white};
                      background: ${(props) => props.theme.green.dark};
                    }
                  }
                }
              }
            }
            .btn-outline-primary {
              border-color:  ${(props) => props.theme.green.dark};
              color:  ${(props) => props.theme.green.dark};
              &:hover {
                color: ${(props) => props.theme.color.white};
                background: ${(props) => props.theme.green.dark};
              }
              &.homecare{
                color: ${(props) => props?.theme?.royalBlue?.dark};
                border-color: ${(props) => props?.theme?.royalBlue?.dark};
                &:hover {
                  color: ${(props) => props?.theme?.royalBlue?.dark};
                  background: ${(props) => props?.theme?.color?.white};
        
                }
              }
            }
          }
          .modal-footer {
            .btn {
              &.btn-primary {
                background:  ${(props) => props.theme.green.dark};
                border-color:  ${(props) => props.theme.green.dark};
              }
            }
          }
        }
      }
    }

    .coupon-modal-main{
      padding: 16px 24px 0px 24px !important ;
      background: linear-gradient(180deg, #F1F6FB 0px, rgba(255, 255, 255, 0) 12px) !important;

      .coupon-title { 
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        text-align: left; 
        margin-bottom: 24px;
      }

      .view-more { 
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        color:  ${(props) => props.theme.colors.primary.green['700']};
        text-align: center;

        span {
          cursor: pointer;
        }
      }

      .referral-list div:last-child{
        border: 0px;
      }

      ul {
        padding-left: 1rem;
      }
    }

    .coupon-modal{
      padding: 16px 24px 16px 24px !important ;
      background: linear-gradient(180deg, #F1F6FB 0px, rgba(255, 255, 255, 0) 12px) !important;

      .coupon-title { 
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        text-align: left; 
        margin-bottom: 24px;
      }

      .view-more { 
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        color:  ${(props) => props.theme.colors.primary.green['700']};
        text-align: center;

        span {
          cursor: pointer;
        }
      }

      .referral-list div:last-child{
        border: 0px;
      }

      ul {
        padding-left: 1rem;
      }
    }

    

    &.orderTrackPopUp{
      .rightBarDialogStyled{
       .modal-body{
        overflow-x: hidden !important;
      }
    }
      iframe{
        max-width:100%
      }
      .showMap{
        .deliveryStatus{
          top: 31px;
          left: 78px;
          background: ${(props) => props.theme.text.dark};
          opacity: 0.75;
          border-radius: 8px;
          display: flex;
          position: absolute;
          z-index: 100;
          color: ${(props) => props.theme.blue.grey};
          font-weight: 500;
          font-size: 12px;
          line-height: 15px;
          width: 150px;
          height: 34px;
          align-items: center;
          .timer {
            margin: 4px 6px 0 8px;
          }
          .deliveryMin {
            color: ${(props) => props.theme.color.white};
            font-weight: 700;
            font-size: 12px;
            line-height: 15px;
          }
        }
        .card_wrapper{
          padding: 18px 22px 28px 24px;
          .mapBox{
            width: 402px;
            height: 360px;
            background: ${(props) => props.theme.color.loyalty};
            border: 1px solid ${(props) => props.theme.color.border};
            border-radius: 8px;
          }
        }
      }
      .card_wrapper{
        padding: 45px 21px 75px;
        p.subtitle{
          font-size: 18px;
          margin-left: 32px;
          width: 84%;
        }
      }
      .orderSucessfull{
        position: absolute;
        width: 447px;
        height: 50px;
        top: 330px;
        background: linear-gradient(180deg, #F1F6FB 0%, rgba(255, 255, 255, 0) 100%);
      }
      .orderTrackDetails{
        .trackPkgHeader{
          padding: 15px 24px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .orderIdDetails{
                span{
                font-weight: 400;
                font-size: 16px;
                line-height: 20px;
                color:${(props) => props.theme.text.dark};
                margin-bottom: 3px;
              }
              p{
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color:${(props) => props.theme.text.medium};
                margin:4px 0 0;
              }
          }

          .deliveryStatusDetails{
            .deliveryTitle{
              margin-bottom: 9px;
              .verification-status {
                font-size: 13px;
                font-weight: 400;
              }
            }
            .express {
              float: right;
            }
          }
          
        }
        .trackPkgDeliveryAddress {
          padding: 23px 42px 14px 24px;
          border-bottom:1px solid ${(props) => props.theme.color.lightGray};

          .addressWrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            span {
              font-weight: 700;
              font-size: 16px;
              line-height: 25px;
            }
            div {
              font-weight: 600;
              font-size: 12px;
              padding: 4px 8px;
              background: ${(props) => props.theme.green.extraLight};
              color: ${(props) => props.theme.green.dark};
              border-radius: 5px;
            }
          }
          p{
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            color: ${(props) => props.theme.text.medium};
            margin-top: 8px;
          }
        }
        .trackPkgInfo{
          padding:24px;
          border-bottom:1px solid ${(props) => props.theme.color.lightGray};
          h5{
            font-size: 18px;
            font-weight: 600;
            line-height: 23px;
            color:${(props) => props.theme.text.dark};
            margin-bottom:0;
          }
          p{  
            font-size: 15px;
            font-weight: 600;
            line-height: 19px;
            color:${(props) => props.theme.text.medium};
            margin:4px 0 0;
            a{
              font-size: 16px;
              line-height: 23px;
              text-decoration:none;
            }
          }
          .contactDetails{
            display:flex;
            margin-top:16px;
            .tel{
              margin:0;
              &:before{
                content: "";
                background: url(${IC_CALL.src}) no-repeat;
                background-size: 100%;
                display: inline-block;
                background-position: center;
                width: 32px;
                height: 32px;
                vertical-align: middle;
                margin-right: 8px;
              }
              a{
                color: ${(props) => props.theme.text.medium};
              }
            }
            .map{
              margin:0 0 0 16px;
              &:before{
                content: "";
                background: url(${IC_LOCATION_GREEN?.src}) no-repeat;
                background-size: 100%;
                display: inline-block;
                background-position: center;
                width: 32px;
                height: 32px;
                vertical-align: middle;
                margin-right: 8px;
              }
              a{
                color: ${(props) => props.theme.green.dark};
              }
            }
          }
        }

        .payment-section {
          padding: 18px 16px;
          margin: 19px 16px 24px;
          border: 1px solid ${(props) => props.theme.color.lightGray};
          box-sizing: border-box;
          border-radius: 8px;
          background-color: ${(props) => props.theme.color.white};
          display: flex;
          flex-direction: column;

          .payment-label {
            font-weight: 600;
            font-size: 16px;
            margin-left: 0px;
            color: ${(props) => props.theme.text.darkest};
          }
          .payment-money-label {
            font-weight: 700;
            font-size: 18px;
            line-height: 23px;
          }
        }

        .deliveryDetails{
          padding: 0px 23px 23px;
          display: flex;
          flex-direction: column;
          .deliveryPersonDetails {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            margin-bottom: 4px;

            .deliveryBy {
              .text{
                font-weight: 600;
                font-size: 10px;
                line-height: 13px;
              }
              .name{
                font-weight: 600;
                font-size: 14px;
                line-height: 18px;
              }
            }
          }
          .phone {
            padding: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            .phoneIcon {
              margin-right: 10px;
            }
            .number{
              font-weight: 600;
              font-size: 16px;
              line-height: 23px;
              color:  ${(props) => props.theme.text.medium};
              margin-bottom: 6px;
            }
          }
        }

        .orderSteps{
          padding:21px 24px;

          .progressbar{
            overflow: hidden;
            padding-left: 0px;

            li{
              position:relative;
              padding-bottom: 40px;
              display:flex;
              align-items: center;

              :before{
                content: "";
                background: ${(props) => props.theme.color.white} url(${IC_RADIO.src}) no-repeat;
                background-size: 24px;
                display: inline-block;
                background-position: 4px 0;
                width: 32px;
                height: 24px;
                z-index:9;
              }
              :after{
                content: "";
                background: ${(props) => props.theme.green.light};
                position: absolute;
                width: 1px;
                height: 100%;
                top: 23px;
                left: 15px;
              }
              :last-child:after{
                content:unset;
              }
              p{
                font-size: 18px;
                font-weight: 600;
                line-height: 23px;
                color: ${(props) => props.theme.text.darkest};
                margin:0 0 0 16px;
                span{
                  display:block;
                  font-weight: 600;
                  font-size: 13px;
                  line-height: 16px;
                  color: ${(props) => props.theme.text.medium};
                  margin-top:4px;
                }
              }
              &.active{
                &:before{
                  content: "";
                  background: url(${IC_RIGHT_GREEN?.src}) no-repeat;
                  background-size: 100%;
                  display: inline-block;
                  background-position: center;
                  width: 32px;
                  height: 32px;
                  z-index:9;
                  margin-top: 6px;
                }
              }
              &.dotted-border:after{
                content:"";
                background-image: linear-gradient(${(props) =>
    props.theme.color.border} 38%, rgba(255, 255, 255, 1) 0%);
                background-size: 3px 6px;
                width: 1.5px;
              }
              &:last-child{
                padding-bottom:0;
              }
            }
          }
        }
      } 
    }

    &.modal_pdpAdvtBox {
      .modalDialogStyled {
        .modal-content {
          .modal-body {
            padding: 24px 24px 0;
            white-space: pre-wrap;
            word-break: break-all;
            
            > div {
              position: sticky;
              bottom: 0;
              left: 0;
              width: 100%;
              background: ${(props) => props?.theme?.color?.white};
              padding: 5px 0 16px;
            }
          }

          .modal-body > div a {
            color: ${(props) => props?.theme?.green?.dark};
            font-size: 16px;
            font-weight: 700;
            text-decoration: none;
            margin-top: 16px;
            display: flex;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  .payment-card-modal{
    .modalDialogStyled{
      .modal-content{
        .modal-body{
          padding-bottom:0;
        }
      }
    }
  }
  .sidebar_apply_coupon_code {
    .modal-body {
      position: relative;

      .couponCodeHeader {
        width: 100%;
        background: ${(props) => props.theme.sectionBox.bodyBg};
        padding: 24px;
        position: sticky;
        top: 0; 
        left: 0;
        z-index: 1101;
      }
    }
  }
  .cardWrapper{
    width: 100%;
  }

  .sidebar-promo-offer-details {
    .promo-card {
      padding: 16px 24px;
      &>div{
        width: 100%;
      }
      .cardWrapper > div{
        width:100%
      }
    }

    .promo-offer-details{
      .pormoDetailHeader{
        padding-left: 18px;
        padding-top: 12px;
        padding-bottom: 8px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 700;
        color: #031a32;
      }
      .pormoDetailDescription{
         font-size: 14px;
         line-height: 20px;
         color: #697f99;
         font-weight: 600;
         padding: 0 24px;
         margin-top: 12px;
      }
      .pormoNotApplicableDetails {
        padding: 0 24px;
        .promoNotApplicable {
            color: #344A5F;
            font-family: Mulish;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 20px;
           
         }   
        .subtitle {
          color: #697F99;
          font-family: Mulish;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
        }
      }
      
    }

    .btn.btn-secondary{
      display: flex;
      width: 417.798px;
      height: 56px;
      padding: 20px 10px 19px 10px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      border-radius: 8px;
      border: 1px solid #388E3C;
      background: #ffffff;
      color: #388E3C;
    }
    .btn.btn-secondary:hover {
        background: #f4faf4;
        color: #388E3C;
    }
    .modal-body { 
      background: linear-gradient(180deg, #F1F6FB 0%, rgba(255, 255, 255, 0.00) 2%) !important;
    }
    .modal-footer {
      box-shadow: 0px -5px 40px 0px rgba(56, 142, 60, 0.08) !important;
    }
  }

  .blurBox {
    filter: blur(2px);
    position: relative;
    z-index: 0;

    ::after {
      content: '';
      position: absolute;
      z-index: 1;
      background: ${(props) => props.theme.blurBg.blue};
      border-radius: 8px;
      opacity: 0.5;
      height: 100%;
      width: 100%;
    }
  }
.right-sider-aster-secure{
  .aster-secure-label{
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .aster-secure-email-text{
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .forget-password{
    font-weight: 400;
    font-size: 15px;
    margin-top: 16px;
    span{
      color:${(props) => props.theme.blue.dark};
      font-weight: 700;
    }
  }
  .invalid-feedback{
    font-weight: 600;
    font-size: 16px;  
  }
  .aster-right-container{
    .card_wrapper{
      padding: 110px 75px 90px 75px;
      .title{
      font-weight: 600;
      font-size: 18px;
      line-height: 23px;
      }
    }
  }
}
  .nav-tabs {
    border-color: ${(props) => props.theme.color.divider};

    .nav-link {
      font-size: 15px;
      font-weight: 700;
      color: ${(props) => props.theme.text.medium};
      border: 0;
      position: relative;

      &::after {
        width: 100%;
        height: 2px;
        background: transparent;
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 2px 2px 0 0;
      }

      &:hover {
        &::after {
          background: ${(props) => props.theme.text.medium};
        }
      }

      &.active {
        color: ${(props) => props.theme.blue.dark};
       
        &::after {
          background: ${(props) => props.theme.blue.dark};
        }
      }
    }

    &.customTab{
      .nav-link {
        padding:.5rem 30px;

        &.active {
          background:transparent;
        }
      }
    }
  }
  .fontbold{
    font-weight: 700;
  }
  .tab-content {
    padding: 20px 0 0 0;
  }

  .font-16 {
    font-size: 16px;
  }
  .profileErrorMessage{
    .card_wrapper {
      p.subtitle{
        width: 100%;
        padding: 0 60px;
        margin-bottom: 20px;
        .message {
          width: 48%;
          margin: 0 auto;
        }
      }
    }  
  }
  .upload_documents_modal {
    .grey-text {
      font-size: 14px;
      line-height: 18px;
      color: ${(props) => props.theme.text.medium};
    }
    .insurance-success-panel {
      .card_wrapper {
        padding: 0;
        .addmembers{
          max-width: 119px;
        }
      }
      &.bgGrey {
        .card_wrapper {
          background-color: ${(props) => props.theme.sectionBox.bodyBg};
        }
      }
    }

    .document_image {
      width: 135px;
      height: 85px;
      object-fit: cover;
      margin-right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${(props) => props.theme.color.white};
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 15px;
      border: 1px solid ${(props) => props.theme.color.border};
      position: relative;

      .delete_image {
        position: absolute;
        z-index: 1;
        width: 30px;
        height: 30px;
        background-color: ${(props) => props.theme.color.red};
        border-radius: 20px;
        text-align: center;
        padding-top: 3px;
        top: 5px;
        right: 5px;
      }
    }

    .uploadDetailBox{
      .uploadTitle{
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        color:${(props) => props.theme.text.dark};
        margin-bottom:7px;
      }
      .uploadDesc{
        display:flex;
        justify-content:space-between;

        .uploadFormat{
          font-weight: 600;
          font-size: 13px;
          line-height: 16px;
          color:${(props) => props.theme.text.medium};
        }
        .uploadCount{
          display:flex;
          align-items:center;
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          color:${(props) => props.theme.text.medium};
          padding:10px 15px;
          border-radius:58px;
          width:72px;
          background-color:${(props) => props.theme.color.white};
          border:1px solid ${(props) => props.theme.color.border} ; 
        }
      }
    }

    .uploadedImageWrapper{
      display:flex;
      justify-content:space-between;

    .uploaded_image {
      width: 194px;
      height: 140px;
      max-width:calc(50% - 8px);
      object-fit: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${(props) => props.theme.color.white};
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 15px;
      border: 1px solid ${(props) => props.theme.color.border};
      position: relative;

      .delete_image {
        position: absolute;
        z-index: 1;
        width: 30px;
        height: 30px;
        background-color: ${(props) => props.theme.color.red};
        border-radius: 20px;
        text-align: center;
        padding-top: 3px;
        top: 5px;
        right: 5px;
      }
    }
  }

    .cancellationReason {
      width: 100%;
      padding: 24px;

      .note {
        font-size: 15px;
        font-weight: 400;
        padding-bottom: 24px;
        color: ${(props) => props.theme.text.darkest};
      }

      .opt {
        padding: 24px 0;
        .form-check {
          label {
            font-weight: 600;
          }
        }
      }

      .bb {
        border-bottom: 1px solid ${(props) => props.theme.color.border};
      }
    }
    .note {
      width: 100%;
      border-radius: 0 0 8px 8px;
      padding: 12px 16px;
      background: ${(props) => props.theme.yellow.off};
      font-size:15px;
      line-height:19px;
      font-weight:400;


      &.withBorder{
        border: 1px solid ${(props) => props.theme.yellow.border};
      }
    }

  }
  .date-picker-input {
    position: relative;
    .react-calendar {
      position: absolute;
      top: 90px;
      z-index: 100;
    }
    .date_field {
      .inputField {
        background-image: url(${IC_CALENDAR.src}) !important;
        background-position: calc(100% - 18px) center;
        background-repeat: no-repeat;
        background-size: 16px;
      }
    }
    .date-icon {
      background: url(${IC_CALENDAR.src}) no-repeat;
      height: 20px;
      width: 20px;
      display: flex;
      position: absolute;
      right: 7px;
      bottom: 14px;
    }
  }
  }
  .prescription_section{
    padding:16px 30px;
  }

  .toggle_information_section{
    padding: 24px;
  }

  .package_tooltip_home {
    .rightBarDialogStyled {
      &.modal-md {
        max-width: 453px;
      }
  }

  .toggle_info {
    padding: 24px 48px 0px 16px;

    .tool-tip-detail-wrapper-main {
      position: relative;
      display: flex;

      .tool-tip-divider {
        position: absolute;
        width: 1px;
        height: 290px; 
        background-color: ${(props) => props?.theme?.blue?.dark};
        flex-shrink: 0;
        left: 34px;

        @media(max-width: 480px) {
          left: 24px; 
          top: 15px;
          height: 245px;
        }
      }

      .tool-tip-detail-wrapper {
        display: flex;
        position: relative;
        flex-direction: column;
        gap: 24px 8px;

        .tool-tip-main-component{
          display: flex;
          flex-direction: row;

          .info-image {
            width: 64px;
            height: 64px;

            @media(max-width: 480px) {
              width: 48px;
              height: 48px;
            }
          }

          .text-content {
            font-size: 14px;
            font-weight: 600;
            color:${(props) => props?.theme?.text?.darkest};
            opacity: 0.6;
          }

          .text-paragraph {
            color: ${(props) => props?.theme?.blue?.greyLight};
            font-size: 12px;
            font-weight: 600;
          }
        }

        >div:nth-child(1) {
          .last-child-parent-home {
            padding: 19px 0px 0px 10px;

            @media(max-width: 480px) {
              padding: 13px 0px 0px 15px;
            }

            @media(max-width: 420px) {
              padding: 4px 0px 0px 15px;
            }
          }
          .last-child-parent {
            padding: 14px 51px 0px 10px;

            @media(max-width: 480px) {
              padding: 13px 0px 0px 15px;
            }

            @media(max-width: 420px) {
              padding: 4px 0px 0px 15px;
            }
          }
        }

        >div:nth-child(2) {
          .last-child-parent-home {
            padding: 2px 54px 0px 10px;

            @media(max-width: 480px) {
              padding: 0px 41px 0px 15px;
              margin-top: -5px;
            }

            @media(max-width: 330px) {
              padding: 0px 0px 0px 15px;
              margin-top: -7px;
            }
          }

          .last-child-parent {
            padding: 13px 45px 0px 10px;

            @media(max-width: 480px) {
              padding: 2px 30px 0px 15px;
            }

            @media(max-width: 320px) {
              padding: 3px 0px 0px 15px;
            }
          }
        }

        >div:nth-child(3) {
          .last-child-parent-home {
            padding: 2px 41px 0px 10px;

            @media(max-width: 480px) {
              padding: 2px 27px 0px 15px;
              margin-top: -10px;
            }

            @media(max-width: 330px) {
              padding: 0px 0px 0px 15px;
              margin-top: -15px;
            }
          }

          .last-child-parent {
            padding: 13px 20px 0px 10px;

            @media(max-width: 480px) {
              padding: 3px 28px 0px 15px;
            }

            @media(max-width: 420px) {
              padding: 2px 0px 0px 15px;
            }

            @media(max-width: 330px) {
              padding: 0px 0px 0px 15px;
              margin-top: -10px;
            }
          }
        }

        >div:last-child {

          .last-child-parent-home {
            padding: 12px 0px 0px 10px;

            @media(max-width: 480px) {
              padding: 3px 0px 0px 15px;
            }

            @media(max-width: 420px) {
              padding: 0px 0px 0px 15px;
              margin-top: -5px;
            }

            @media(max-width: 330px) {
              margin-top: -10px;
            }
          }

          .last-child-parent {
            padding: 12px 0px 0px 10px;

            @media(max-width: 480px) {
              padding: 3px 0px 0px 15px;
            }

            @media(max-width: 420px) {
              padding: 0px 0px 0px 15px;
              margin-top: -5px;
            }
            
            @media(max-width: 330px) {
              margin-top: -10px;
            }
          }
        }
      }
    }
  }

  .infoText{
    font-size:15px;
    line-height:19px;
    font-weight:380;
    margin-bottom:12px;
  }
  

  .pointer {
      width: calc(100% - 20px);
      font-size: 16px;
      font-weight: 600;
      margin: 0 0 0 20px;
      padding: 0;

      li {
        margin: 0 0 16px 0;
      }
    }
  .prescription_instructions {
    width: 100%;
    padding: 24px 30px;
    .prescription_img {
      width: 100%;
      max-height: 584px;
      border: 1px solid ${(props) => props.theme.color.border};
      border-radius: 8px;
      overflow: hidden;
      margin: 0 0 24px 0;
      &.no-border{
        border:0;
      }
    }

    .pointers {
      width: calc(100% - 20px);
      font-size: 16px;
      font-weight: 600;
      margin: 0 0 0 20px;
      padding: 0;

      li {
        margin: 0 0 16px 0;
      }
    }
  } 

  .recordDetailsWrapper {
    overflow-y: hidden !important;
    .record-wrapper {
      padding: 24px;
      .vitalsSign{
        display: flex;
        .sign{
          border-bottom: 1px solid ${(props) => props?.theme?.color?.border};
          .signs{
            border-left: 1px solid ${(props) => props?.theme?.color?.border};
            color: ${(props) => props?.theme?.royalBlue?.darkGrey};
            border-bottom: 0px;
            margin-top: 19px;
            font-size: 14px;
            line-height: 18px;
            height: 25px;
            padding-left: 10px;
            text-align: center;
            width: 32px;
          }
        }
      }

      .bloodPressure{
        display: flex;
        flex-direction: column;
        .vitalsSign{
          display: flex;
          .sign{
            border-bottom: 1px solid ${(props) => props?.theme?.color?.border};
            .signs{
              border-left: 1px solid ${(props) => props?.theme?.color?.border};
              color: ${(props) => props?.theme?.royalBlue?.darkGrey};
              border-bottom: 0px;
              margin-top: 19px;
              font-size: 14px;
              line-height: 18px;
              height: 25px;
              padding-left: 10px;
              text-align: center;
              .diastolic{
                width: 60px;
              }
            }
          }
        }
        .diagonal_line{
          border-left: 1px solid ${(props) => props?.theme?.blue?.grey};
          width: 5px;
          height: 33px;
          margin:6px 0px 0px 3px;
          padding: 0px;
          transform: rotate(18deg);
        }
      }

      .vitalSign{
        .inputField{
          padding-bottom: 20px !important;
          color: black;
          &:focus-visible {
            border-color:${(props) => props?.theme?.color?.borderLight} !important;
            outline: 0;
            -webkit-box-shadow: none;
            box-shadow: none;
          }
        }
      }

      h2 {
        font-size: 13px;
        font-weight: 600;
        line-height: 16px;
        color: ${(props) => props?.theme?.text?.medium};
        margin-bottom:0px;

        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: ${(props) => props?.theme?.text?.medium};
        }
      }
    }
      .header {
        font-weight:500;
        font-size: 16px;
        line-height: 20px;
        color: ${(props) => props.theme.text.dark};

        span {
          font-weight: 600;
          font-size: 14px;
          line-height: 18px;
          color: ${(props) => props.theme.text.medium};
        }
      }

      .form-label {
        font-weight: 600;
        font-size: 17px;
        line-height: 21px;
        color: ${(props) => props?.theme?.text?.dark};
        margin: 0px;
      }

      .form-text {
        display: block;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: ${(props) => props.theme.text.medium};
        margin: 0px 0px 9px 0px;
      }

      h2 {
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        color: ${(props) => props?.theme?.text?.medium};
        margin-bottom: 11px;

        span{
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: ${(props) => props.theme.text.medium};
        }
      }

      .invalid-feedback {
        font-size: 16px;
        font-weight: 600;
        padding-left: 25px;
        background: url(${IC_PENDING_RED.src}) no-repeat 0 4px / 18px;
        color: ${(props) => props.theme.verification.red.main};
      }

      .group-wrapper {
        position: relative;
        width: 178px;
        margin: 0px;

        .element-wrapper {
          background: ${(props) => props.theme.color.white};
          border: 1px solid ${(props) => props.theme.color.lightGray};
          box-sizing: border-box;
          border-radius: 8px;
          width: 178px;
          height: 56px;

          input[type='text'] {
            border: 0px solid ${(props) => props.theme.color.white};
            width: 108px;
            height: 56px;
            background-color: transparent;

            &:focus {
              box-shadow: none;
            }
          }
        }
        .element-overlay {
          position: absolute;
          width: 70px;
          height: 56px;
          right: 0px;
          top: 0px;
          background: ${(props) => props.theme.color.divider};
          border: 1px solid ${(props) => props.theme.color.lightGray};
          box-sizing: border-box;
          border-radius: 0px 8px 8px 0px;
          font-weight: 600;
          font-size: 16px;
          line-height: 56px;
          text-align: center;
          color: ${(props) => props.theme.text.medium};
        }

        &.is-invalid {
          .element-wrapper {
            border-color: ${(props) => props.theme.verification.red.main};
          }
          .element-overlay {
            border-color: ${(props) => props.theme.verification.red.main};
            border-left: 1px solid ${(props) => props.theme.color.lightGray};
          }
        }
        
        .divider {
          position: absolute;
          right: -18px;
          top: 15px;
        }
      }
    }

    .sm_waitingrm_wrapper {
      padding: 0px 20px 20px 20px;

      .vitalsDisclaimer {
        display: flex;
        flex-direction: row;
        padding: 12px 8px;
        margin: 12px 0px 0px 0px;
        height: auto;
        background-color: ${(props) => props.theme.blue.iconBg};
        border-radius: 8px;

        .vitalsDisclaimerText {
          margin-left: 8px;
          font-size: 14px;
          line-height: 18px;
          font-weight: 400;
          color: ${(props) => props.theme.text.medium};
        }
      }

      h2 {
        font-size: 13px;
        font-weight: 600;
        line-height: 16px;
        color: ${(props) => props?.theme?.text?.medium};
        margin-bottom:0px;

        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          color: ${(props) => props?.theme?.text?.medium};
        }
      }

      .vitalsSign{
        display: flex;
        margin-top: 20px;
        .sign{
          border-bottom: 1px solid ${(props) => props?.theme?.color?.border};
          .signs{
            border-left: 1px solid ${(props) => props?.theme?.color?.border};
            color: ${(props) => props?.theme?.royalBlue?.darkGrey};
            border-bottom: 0px;
            margin-top: 19px;
            font-size: 14px;
            line-height: 18px;
            height: 25px;
            padding-left: 10px;
            text-align: center;
            width: 32px;
          }
        }
      }

      .bloodPressure{
        display: flex;
        flex-direction: column;
        .blood-wrapper{
          width: 490px;
        }
        .vitalsSign{
          display: flex;
          .sign{
            border-bottom: 1px solid ${(props) => props?.theme?.color?.border};
            .signs{
              border-left: 1px solid ${(props) => props?.theme?.color?.border};
              color: ${(props) => props?.theme?.royalBlue?.darkGrey};
              border-bottom: 0px;
              margin-top: 19px;
              font-size: 14px;
              line-height: 18px;
              height: 25px;
              padding-left: 10px;
              text-align: center;
              .diastolic{
                width: 60px;
              }
            }
          }
        }
      
        .diagonal_line{
          border-left: 1px solid ${(props) => props?.theme?.blue?.grey};
          width: 5px;
          height: 33px;
          margin:6px 0px 0px 3px;
          padding: 0px;
          transform: rotate(18deg);
        }
      }

      .vitalSign{
        .inputField{
          padding-bottom: 20px !important;
          color: black;
          &:focus-visible {
            border-color:${(props) => props?.theme?.color?.borderLight} !important;
            outline: 0;
            -webkit-box-shadow: none;
            box-shadow: none;
          }
        }
      } 
     }

      .header {
        font-weight:600;
        font-size: 14px;
        line-height: 20px;
        color: ${(props) => props.theme.text.dark};

        span {
          font-weight: 600;
          font-size: 14px;
          line-height: 18px;
          color: ${(props) => props.theme.text.medium};
        }
      }

      .form-label {
        font-weight: 600;
        font-size: 17px;
        line-height: 21px;
        color: ${(props) => props.theme.text.dark};
        margin: 0px;
      }

      .form-text {
        display: block;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: ${(props) => props.theme.text.medium} !important;
        margin: 0px 0px 9px 0px;
      }

      h2 {
        font-weight: 700;
        font-size: 17px;
        line-height: 21px;
        color: ${(props) => props?.theme?.text?.dark};
        margin-bottom: 8px;
      }

      .sm_weight {
        margin-top: 24px !important;
      }

      .border-bottom{
        border-bottom: none !important;
      }

      .invalid-feedback {
        font-size: 16px;
        font-weight: 600;
        padding-left: 25px;
        background: url(${IC_PENDING_RED.src}) no-repeat 0 4px / 18px;
        color: ${(props) => props.theme.verification.red.main};
      }

      .group-wrapper {
        position: relative;
        width: 100%;
        margin: 0px;

        .element-wrapper {
          background: ${(props) => props.theme.color.white};
          border: 1px solid ${(props) => props.theme.color.lightGray};
          box-sizing: border-box;
          border-radius: 8px;
          width: 100%;
          height: 56px;

          input[type='text'] {
            border: 0px solid ${(props) => props.theme.color.white};
            width: 100%;
            height: 56px;
            background-color: transparent;

            &:focus {
              box-shadow: none;
            }
          }
        }
        .element-overlay {
          position: absolute;
          width: 70px;
          height: 56px;
          right: 0px;
          top: 0px;
          background: ${(props) => props.theme.color.divider};
          border: 1px solid ${(props) => props.theme.color.lightGray};
          box-sizing: border-box;
          border-radius: 0px 8px 8px 0px;
          font-weight: 600;
          font-size: 16px;
          line-height: 56px;
          text-align: center;
          color: ${(props) => props.theme.text.medium};
        }

        &.is-invalid {
          .element-wrapper {
            border-color: ${(props) => props.theme.verification.red.main};
          }
          .element-overlay {
            border-color: ${(props) => props.theme.verification.red.main};
            border-left: 1px solid ${(props) => props.theme.color.lightGray};
          }
        }
        
        .divider {
          display: none;
        }
        
      }

      .sm_enter_text{
        padding: 0px;
        gap: 10px;
        border-radius: 0px;
        border: none !important;
        border-bottom: 1px solid ${(props) => props?.theme?.blue?.grey} !important; 
        .form-label{
          padding-bottom: 0 !important;
        }
        input[type='text'] {
          height: 30px !important;
          padding: 0 !important;
          border-bottom: none !important;
        }
      }
    }
  }

  .record-select-wrapper {
    .selectRecordWrapper {
      padding: 24px;

      .recordTitle{
        font-weight: 600;
        font-size: 15px;
        line-height: 19px;
        color: 1px solid ${(props) => props.theme.text.darkest};
        margin: 0 0 21px 0;
      }
      .recordCard{
        width: 100%;
        border: 1px solid ${(props) => props.theme.color.lightGray};
        border-radius: 8px;
        margin: 0 0 16px 0;
  
        .topArea {
          width: 100%;
          padding: 12px 16px;
          display: flex;
          background-color: ${(props) => props.theme.color.divider};
          border-radius: 8px 8px 0 0;
          .date {
            display: flex;
            align-items: center;
            position: relative;
            font-size: 13px;
     
            .value {
              font-weight: 600;
              margin-right: 15px;
            }
            &::after {
              content: '';
              width: 6px;
              height: 6px;
              background: ${(props) => props.theme.blue.grey};
              border-radius: 50%;
              position: absolute;
              top: 50%;
              right: 0;
              transform: translateY(-50%);
            }
          }
          .time {
            font-size: 13px;
            display: flex;
            align-items: center;
   
            .value {
              font-weight: 600;
              margin-left: 10px;
            }
          }
          .consultType {
            font-weight: 600;
            font-size: 14px;
            line-height: 18px;
            color: ${(props) => props.theme.blue.light};
            padding:6px 12px;
            background-color:${(props) => props.theme.color.white};
            border: 1px solid ${(props) => props.theme.blue.medium};
            border-radius: 6px;
            position:relative;

            &::before{
              position: absolute;
              content:"";
              left:0;
              top:5px;
              width: 3px;
              height: 20px;
              background:  ${(props) => props.theme.blue.light};
              border-radius: 6px 0px 0px 6px;
              transform: matrix(-1, 0, 0, 1, 0, 0);
            }
          }
        }
        .detailsArea {
          width: 100%;
          padding: 16px 20px;
          display: flex;
          flex-direction: column;

          .otherDetails {
            width: 100%;
            padding-bottom: 20px;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-content: stretch;
            align-items: center;

            .doctorInfo {
              display: flex;
              align-items: center;

              .documentTypeIcon{
                margin-right:16px;
                min-width:50px;
              }
              .documentTypeName{
                font-weight: 600;
                font-size: 17px;
                line-height: 21px;
              }
            }
          }
        }
        .bottomArea{
          padding:0 16px 20px; 

          .reportTitle{
            font-weight: 600;
            font-size: 15px;
            line-height: 19px;
            margin-bottom:9px;
          }
          .attachCount{
            font-weight: 600;
            font-size: 13px;
            line-height: 16px;
            color:  ${(props) => props.theme.blue.dark};
            margin-left:9px;
          }
        }
      }
      .divider {
        width: 100%;
        height: 1px;
        background: ${(props) => props.theme.color.lightGray};
      }
    }
  }
    .country_form_container{
        .rightBarDialogStyled{ 
          .modal-content{ 
            .required_note{
              font-size: 15px;
              line-height: 19px;
              margin-bottom: 30px;
              span{
                font-weight: 600;
              }
            }
             .custom-country-dropdown{
              .dropdown-menu{
                  height:185px;
                }
              }
            .modal-footer{
             background-color: transparent;
             box-shadow: none;
            }
          }
        }
     }

  .faq-contact-wrapper{
    &.modal {
      .rightBarDialogStyled{
        &.modal-dialog {
          width: 450px;
          max-width: 100%;
        }
        .modal-content{
          .modal-header{
            border-bottom-color: ${(props) => props.theme.color.divider};
            box-shadow: none;
          }
        }
      }
    }
    &.with-btn{
      .rightBarDialogStyled{
        .modal-content{
          .modal-body{
            bottom:92px;

            &.fullHeight {
              bottom: 0;
            }
          }
        } 
      }
    }
    
    .form-wrapper{
      .header{
        display:flex;
        flex-direction:row;
        padding:24px 24px 0px 24px;
        &.border{
          border-bottom: 1px solid ${(props) => props.theme.color.lightGray};
        }

        .member-image {
          width: 52px;
          height: 52px;
          // background-color: ${(props) => props.theme.color.lightGray};
          overflow: hidden;
          border-radius: 50%;
          display: inline-block;
          margin: 0px 15px 0px 0px;
          // margin:0px 15px 0px 0px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          img {
            width: auto;
            height: 100%;
          }
          &.avtarName {
            width: 52px;
            height: 52px;
            display: inline-flex;
          }
        }
        .user-info {
          .name {
            font-weight: 700;
            font-size: 18px;
            line-height: 23px;
            margin: 0px;
            color: ${(props) => props.theme.text.dark};
          }

          .mail {
            font-weight: 600;
            font-size: 14px;
            line-height: 18px;
            margin: 0px;
            color: ${(props) => props.theme.text.medium};
          }
        }

        .label-info {
          font-weight: 600;
          font-size: 17px;
          line-height: 21px;
          color: ${(props) => props.theme.text.medium};
        }
      }

      .contact-form-wrapper {
        padding: 24px;

        .text_remain_count {
          color: #78909c;
          font-size: 13px;
          font-style: normal;
          font-weight: 600;
          line-height: 16px;
          text-align: right;
          padding-top: 8px;
        }

        .form-label {
          font-size: 16px;
          line-height: 20px;
          color: ${(props) => props?.theme?.text?.medium};
          font-weight: 400;
        }

        .thanks-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          margin-top: 100px;

          .tanks-img {
            text-align: center;
            display: flex;
            align-items: center;
          }

          .name-thanks {
            font-weight:700;
            font-size: 24px;
            line-height: 30px;
            text-align: center;
            color: ${(props) => props.theme.text.dark};
          }

          .thanks-detail {
            font-weight: 600;
            font-size: 17px;
            line-height: 21px;
            text-align: center;
            color: ${(props) => props.theme.text.medium};
            width: 350px;
            margin: 0px auto;
          }
          .ok-btn{
            height:56px;
            margin: 0;
          }
        }
      }
    }
  }

  .right-side-wrapper{
    &.modal {
      .rightBarDialogStyled{
        &.modal-dialog {
          width: 450px;
          max-width: 100%;
        }
        .modal-content{
          .modal-header{
            border-bottom-color: ${(props) => props.theme.color.divider};
            box-shadow: none;
          }
        }
      }
    }
    &.with-btn{
      .rightBarDialogStyled{
        .modal-content{
          .modal-body{
            bottom:92px;

            &.fullHeight {
              bottom: 0;
            }
          }
        } 
      }
    }
  }

  .faq-contact-wrapper {
    .form-wrapper {
      .faq-border {
        border-bottom: 1px solid ${(props) => props.theme.color.borderLight};
      }
    }
    .contact-error-text {
      .invalid-feedback {
        font-size: 16px;
      }
    }
  }
  .right-side-bar-yellow-toast{
    .yellow-dark-box{
      &.floating-wrapper{
        top: 85px;
        right: 0;
        width: 450px;
        z-index: 291;
         @media (max-width: 450px) {
            width: 100%;
         }
      }
    }
  }
.error-invalid-feedback{
  .invalid-feedback{
     font-size: 16px !important;
    font-weight: 600;
  }
}
.right-side-bar-card-list-wrapper {
  &.modal{
    .rightBarDialogStyled{
      .modal-content{
        .modal-body{
          &.whiteBg{
            background-color: ${(props) => props.theme.sectionBox.bodyBg};
            padding-top: 12px;
          }
        }
      }
    }
  }
  .card-list-wrapper{
     border: 1px solid ${(props) => props.theme.color.borderLight};
     background-color: ${(props) => props.theme.color.white};
    border-radius: 8px;
    margin: 12px 24px 24px 24px;
    min-height: 153px;
    display: grid;
    background-image: url(${IC_CARD_WORLD.src});
    background-size:100%;
    &.card-disable{
       background-color: ${(props) => props.theme.sectionBox.bodyBg};
       .form-check .form-check-input[type='radio'] {
         opacity:0.4;
         cursor: not-allowed;
       }
    }
    .card-number {
         span {
          margin: 16px 10px 0px 0px;
           font-weight: 700;
            font-size: 17px;
         }
       }
    .image-card-section{
      display: flex;
      margin-bottom: 16px;
      margin-top: 17px;
      .ic-image-card{
        max-width:67px!important;
        img{
          max-width:67px!important;
        }
      }
    }
    .card-default-text{
      display: inline-block;
      background: ${(props) => props.theme.blue.iconBg};
      border-radius: 7px 0px;
      padding: 5px 12px;
      font-weight: 700;
      font-size: 13px;
      color:${(props) => props.theme.blue.light};
      text-transform: capitalize;
      width: fit-content;
    }
     .payment-info-section {
        display: flex;
        justify-content: space-between;
        padding: 12px 17px;
        align-items: center;
        .card-name {
        font-weight: 600;
          font-size: 16px;
        }
      .card-date-info {
        display: flex;
        align-items: center;
        .card-date {
          font-weight: 600;
          font-size: 15px;
          text-align: right;
         .expire-text {
           color: ${(props) => props.theme.text.medium};
           font-size: 13px;
           
         }
         .expire-red-text {
              color: ${(props) => props.theme.color.red};
            }
        }
      }
    }
  }
  .card-rl-spacing{
    padding:0 17px;
  } 
}
.not-allowed-card{
  cursor: not-allowed!important;
}
.checkout-secure-modal{
  .modalDialogStyled {
    width: 468px;
    height: 253px;
    .modal-content{
      .modal-footer{
        padding: 5px 24px 24px;
      }
    }
  }
}
.checkout-failure-modal {
  .modalDialogStyled {
    width: 468px;
    @media (max-width: 480px) {
      width: auto;
    }
    .modal-content{
      .modal-body {
        padding: 24px 24px 0 24px;
      }
      .payment-failure-container {
        .payment-failure-header {
          font-size: 20px;
          font-weight: 700;
          @media (max-width: 480px) {
            font-size: 16px;
          }
        }
       .payment-failure-body {
          padding: 24px 0;
          font-size: 16px;
          @media (max-width: 480px) {
            padding: 16px 0;
          }
          .payment-failure-inner {
            background: ${(props) => props.theme.yellow.off};
            padding: 16px 0;
            color: ${(props) => props.theme.text.dark};
            font-weight: 400;
            border-radius: 8px;

            @media (max-width: 480px) {
              padding: 8px 40px;
              text-align: left;
              font-size: 15px;
            }
          }
       } 
       .payment-failure-footer {
        padding: 24px 0 0 0;
        .payment-failure-caption {
          font-weight: 400;
          text-align: left;
          padding: 0 12px 12px 12px;
          width: 90%;
          @media (max-width: 480px) {
            font-size: 15px;
            width: 100%;
          }
          span {
            font-weight: 700;
          }
        }
        .payment-failure-method {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 10px;
          > div {
            display: flex;
            align-items: center;
            overflow: visible !important;

            div {
              margin-left: 8px;
            }
          }
         } 
       }
      }
      .modal-footer {
        display: flex;
        flex-direction: column;
        padding: 0 24px 8px 24px;
        button {
          &:first-child {
            order: 2 !important;
            width: 100%;
            margin: 0;
            background: transparent;
            border: none;
          }
          &:last-child {
            order: 1 !important;
            width: 100%;
          }
        }
      }
    }
  }
}
.rxupload_scroll_container{
  max-height: 222px;
  border: 1px solid ${(props) => props.theme.color.borderLight} !important;
  border-radius: 8px !important;
  overflow-y: auto;
}
.rxupload_disclaimer_product{
  padding: 12px;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  gap: 12px;
  flex-direction: column;
}

.upload-prescription-modal {
  .modalDialogStyled {
    width: 468px;
    @media (max-width: 430px) {
      width: calc(100% - 16px) !important;
    }
    .modal-content{
      width: 100%;
      .modal-body {
        padding: 0px
      }
      .upload-prescription-container {
        .upload-prescription-header {
          display: flex; 
          color: ${(props) => props.theme.colors.neutral.darkBlue['700']};
          line-height: 24px;
          font-size: 20px;
          font-weight: 700;
          text-align: left;
          padding: 32px 24px 0px 24px;
          @media (max-width: 480px) {
            font-size: 16px;
            margin-left: 0px;
          }
        }
          .header-text {
                       
          }
          .header-icon {
            position: absolute;
            top: 22px;
            right: 22px;
          }

          .header-icon .close-icon {
            width: 16px;
            height: 15.883px;
            cursor: pointer;
          }
          .upload-prescription-body {
            font-size: 16px;
             padding: 0px 24px;
            @media (max-width: 430px) {
             
            }
          .upload-prescription-inner {
            background: ${(props) => props.theme.yellow.off};
            padding: 16px 0;
            color: ${(props) => props.theme.text.dark};
            font-weight: 400;
            border-radius: 8px;

            @media (max-width: 480px) {
              padding: 8px 40px;
              text-align: left;
              font-size: 15px;
            }
          }
       } 
       .upload-prescription-footer {
        padding: 24px 0 0 0;
        .upload-prescription-caption {
          font-size: 16px;
          line-height: 20px;
          font-weight: 500;
          font-weight: 400;
          color: var(--Typography-colors-Placeholder, #697F99);
          text-align: left;
          width: 100%;
          margin-bottom: 16px;
          @media (max-width: 480px) {
            font-size: 15px;
            width: 100%;
          }
          span {
            font-weight: 700;
          }
        }
        .upload-prescription-method {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 10px;
          > div {
            display: flex;
            align-items: center;
            overflow: visible !important;

            div {
              margin-left: 8px;
            }
          }
         } 
       }
      }
      .modal-footer {
        display: flex;
        flex-direction: column;
        padding: 24px 24px 24px 24px;
        button {
          &:first-child {
            order: 2 !important;
            width: 100%;
            margin: 0;
            background: transparent;
            border: none;
          }
          &:last-child {
            order: 1 !important;
            width: 100%;
          }
        }
      }
    }
  }
}
 
.instore-pmt-modal{
  .modalDialogStyled {
    width: 896px;
    height: 253px;
    .modal-content{
      .modal-footer{
        padding: 5px 24px 24px;
      }
      .modal-header {
        border-bottom: 0;
      }
      .modal-body {
        padding: 0px 32px 32px 32px;
      }
    }
  }


  .invalid-feedback {
    font-size: 10px !important;
  }

  .left-content, .right-content {
    border: 1px solid ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['50']};
    border-radius: 8px;
    padding: 16px;
    align-items: center;
    text-align: center;
  }

  .left-content {
    margin-right: 16px;
  }

  .right-content {
    h2 {
      font-weight: 700;
      font-size: 17px;
      line-height: 21px;
      color: #031a32;
      padding-bottom: 16px;
      margin: 0;
      text-align: left;
    }

    .order-summary-wrapper {
        display: flex;
        justify-content: space-between;
        font-weight: 600  !important;
        font-size: 15px !important;
        line-height: 19px;
        color: ${(props) => props?.theme?.text?.dark};
        background: ${(props) => props?.theme?.color?.white};
        border: 1px solid ${(props) => props?.theme?.color?.border};
        border-radius: 8px;
        padding: 0;
        flex-direction: column;

        .order-detail-wrapper {
          box-sizing: border-box;
          padding: 20px 19px;
          position: relative;
          width: 100%;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid ${(props) => props?.theme?.color?.border};

        .info {
            margin-top: 3px;
            margin-left: 4px;
          }
          .infostand {
            margin-top: 3px;
            margin-left: 4px;
          }
          .inlabel {
            display: flex;
          }
          .labelstandard {
            display: flex;
          }

          .earned-points {
            font-weight: 700;
            font-size: 16px;
            line-height: 20px;
            color: ${(props) => props?.theme?.text?.dark};
            text-align: right;
            span {
              display: block;
              font-weight: 600;
              font-size: 13px;
              line-height: 16px;
              color: ${(props) => props?.theme?.text?.medium};
              text-align: right;
            }
          }
          
          .label {
            color: ${(props) => props?.theme?.text?.darkest};
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            .coupon-discount-label {
              color: ${(props) => props?.theme?.green?.light};
              font-weight: 600;
              display: flex;
            }
          }
          .value {
            color: ${(props) => props?.theme?.text?.dark};
            font-size: 16px;
            line-height: 20px;
            font-weight: 700;
            white-space: nowrap;
            display: flex;
            flex-direction: row-reverse;

            .cancel-price {
              text-decoration: line-through;
              color: ${(props) => props?.theme?.text?.medium};
              font-size: 15px;
              margin-right: 5px;
            }

            &.pay-by-point-value {
              color: ${(props) => props?.theme?.mandalay?.dark};
            }

            &.coupon-discount-value {
              color: ${(props) => props?.theme?.green?.light};
            }
          }
          .information-description {
            font-weight: 600;
            font-size: 15px;
            line-height: 19px;
            color: ${(props) => props?.theme?.text?.medium};

            span {
              font-weight: 700;
              font-size: 15px;
              line-height: 19px;
              color: ${(props) => props?.theme?.text?.dark};
            }
          }
          &:last-child {
            border-bottom: none;
          }

          &.final-paid {
            background: ${(props) => props?.theme?.grey?.greyF4};
            padding: 21px 17.5px 21px 17.5px;

            .to-be-paid {
              font-weight: 700;
              font-size: 16px;
              align-items: center;
              display: flex;
            }

            .final-price {
              font-weight: 700;
              font-size: 18px;
              line-height: 23px;
              color: ${(props) => props?.theme?.text?.dark};
              text-align: right;

              span {
                display: block;
                font-weight: 600;
                font-size: 13px;
                line-height: 16px;
                color: ${(props) => props?.theme?.text?.medium};
              }
            }
          }
        }
      }
  }

  .complete-pmt-txt {
    justify-content: center;
    margin-top: 13px;
    color: ${(props) => props?.theme?.colors?.primary?.green?.['700']};
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
  }

  .emp-details {
    margin-top: 16px;
    border: 1px solid ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['50']};
    padding: 11px;
    border-radius: 8px;
    text-align: left;
    .title {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      text-align: left;
    }
    .btn.btn-outline-success {
        width: 150px !important;
        height: 40px;
        font-size: 16px;
        color: ${(props) => props?.theme?.color?.white};
        border-color: ${(props) => props?.theme?.green.dark};
        border-radius: 8px;
        background: ${(props) => props?.theme?.green.dark};
        margin-top: 16px;
      }
  }
  
}


  .modalVerification {
    > .title {
      color: ${(props) => props.theme.text.medium};
      line-height: 100%;
      margin: 0 0 15px 0;
    }

    .phoneNumber {
      font-size: 20px;
      font-weight: 700;
      margin: 0 0 15px 0;
    }

    .otpBox {
      width: 100%;
      margin: 0 0 30px 0;
      display: flex;
      flex-direction: column;

      .otpTextBox {
        margin: 0 0 20px 0;
        display: flex;
        flex-direction: row;

        .otp {
          width: auto;
          margin-right: 15px;

          .inputField {
            text-align: center;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .otherDetails {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .timer {
          font-size: 14px;
        }

        .reSend {
          font-size: 14px;

          .link {
            color: ${(props) => props.theme.text.medium};
            font-weight: 700;
            margin-left: 5px;
            text-decoration: none;
            cursor: pointer;

            &.enabled{
              color: ${(props) => props.theme.blue.dark};
            }
          }
        }
      }
    }
  }
.insurance-consent-form-modal{
  .modalDialogStyled{
     .modal-content{ 
       .modal-header{ 
         .modal-title {
           text-align: left;
          }
        }
       .modal-body {
          padding: 0px; 
        }
     }
   }
  .content-wrapper{
    iframe{
      height: calc(100vh - 220px);
    }
    
  }
}
  .linkHelp {
    display: flex;
    align-items: center;
    text-decoration: none;

    .ic {
      display: flex;
      margin-right: 5px;
    }
    .text {
      color: ${(props) => props.theme.blue.dark};
      font-size: 16px;
      font-weight: 700;
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .cursor-pointer--not-allowed {
    cursor: not-allowed;
  }
  .remove-favourite-modal {
    .font_22 {
      font-size: 22px;
      line-height: 28px;
      font-weight: 700;
    }
  }
  .remove-modal {
    .modal-footer  {
     padding-top: 0!important;
    }
  }
.blank-card-overflow-unset{
 overflow:unset !important;
}
  .no-hover-effect{
    .btn.btn-secondary:hover {
      color: ${(props) => props.theme.blue.dark};
      background: ${(props) => props.theme.blue.off};
      border-color:  ${(props) => props.theme.blue.off};
    }
  }
  .btn.btn-secondary:hover {
      color: ${(props) => props.theme.blue.dark};
      background: ${(props) => props.theme.blue.off};
      border-color:  ${(props) => props.theme.blue.off};
    }
 .btn.btn-primary:hover {
  background: ${(props) => props.theme.blue.dark};
  border-color: ${(props) => props.theme.blue.dark}; 
}
  .documents-modal {
    .documents-modal {
      padding: 80px 15px 0;
      height: 100vh;
      box-sizing: border-box;
    }

    &.modal {
      .modalDialogStyled {
        .modal-content {
          background-color: ${(props) => props.theme.color.black}50;

          .modal-body {
            padding: 0 !important;
          }
        }
      }
    }

    .document_header {
      position: absolute;
      background: ${(props) => props.theme.color.black}50;
      top: 0;
      left: 0;
      right: 0;
      padding: 15px 30px;
      z-index: 1;

      .fileDetails {
        width: 100%;
      }

      .document_file_name {
        color: ${(props) => props.theme.color.white};
        font-size: 18px;
        line-height: 23px;
        font-weight: 700;
        max-width:35vw;
        white-space:nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
      }

      .pagination {
        width: 100%;
        color: ${(props) => props.theme.color.white};
        font-size: 18px;
        font-weight: 700;
      }

      .document_report_type {
        font-size: 12px;
        line-height: 18px;
        color: ${(props) => props.theme.color.white};
        text-align: left;
      }
    }

    .image_wrapper {
      width: 90%;
      max-width: 90%;
      height: calc(100vh - 180px);
      position: relative;
      display: flex !important;
      align-items: center;
      justify-content: center;
      margin: 0px auto;
      padding: 0 15px;

      > div {
        position: static !important;
      }
    }

    iframe {
      height: calc(100vh - 180px);
      padding: 0 15px;
    }
  }

  .selectAddressModal {
    z-index: 1101;

    .modal-content {
      .modal-body {
        background: ${(props) => props.theme.sectionBox.bodyBg} !important;
      }
    }

    .modal-title {
      display: flex !important;

      .btn {
        margin: 0 !important;
        padding: 0 !important;
      }
    }

    .input-group.is-invalid {
      margin-bottom: 2.5rem;
    }

    .card_wrapper {
      padding: 110px 60px 90px 60px;
    }

    .content {
      width: 100%;
      padding: 24px;

      .chkPrimaryAddress {
        .form-check {
          label { 
            color: ${(props) => props.theme.text.medium};
            font-weight: 600;
          }
        }
      }

      input {
        background-color: #fbfdff !important;
      }

      .country_dropdown {
        background-color: #fbfdff !important;
      }

      .label_optional {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 0.5rem;
        .optionalTitle {
          color: ${(props) => props.theme.text.medium};
        }
      }
      .form-label-none {
        .form-label {
          display: none;
        }
      }

      .form-label {
        color: ${(props) => props.theme.text.medium} !important;
      }

      .searchBar {
        width: 100%;
        background: transparent;
        padding: 16px;
        margin: 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;

        .searchField {
          .form-control {
            padding-left: 45px;
            background: url(${IC_SEARCH.src}) no-repeat 17px 50% / 18px;
            background-color: ${(props) => props.theme.color.white};
          }
        }
      }

      .mapBox {
        width: 100%;
        min-height: 180px;
        height: 356px;
        margin: 0 0 16px 0;
        border: 1px solid ${(props) => props.theme.color.border};
        border-radius: 8px;
        overflow: hidden;
        position: relative;

        &.small {
          height: 120px;
          margin: 0 0 30px 0;
        }
      }

      .locationList {
        width: 100%;

        .locationTitle {
          width: 100%;
          font-size: 17px;
          font-weight: 700;
          padding: 10px 0 16px 0;
          margin: 0 0 16px 0;
          border-bottom: 1px solid ${(props) => props.theme.color.border};
        }

        .deliveryItem {
          width: 100%;
          background: url(${IC_LOCATION_BLACK.src}) no-repeat 0 5px / 18px;
          padding: 0 0 0 30px;
          margin: 0 0 20px 0;
          line-height: 20px;
          cursor: pointer;

          .place {
            font-size: 18px;
            font-weight: 600;
            margin: 0 0 4px 0;
            padding-top: 4px;
          }

          .address {
            color: ${(props) => props.theme.text.medium};
            font-size: 16px;
            font-weight: 400;
            
          }
        }
      }
      .invalid-feedback-message {
        display: block;
        font-size: 12px;
        font-weight: 600;
        padding-left: 25px;
        background: url(${IC_PENDING_RED.src}) no-repeat 0 50% / 18px;
        color: ${(props) => props.theme.verification.red.main};
      }
      .btnRow {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .saved {
          font-size: 20px;
          font-weight: 700;
          line-height: 25px;
        }
        .use-diff-location {
          font-size: 16px;
          font-weight: 700;
          line-height: 20px;
          display: flex;
          align-items: center;
          cursor: pointer;
          color: ${(props) => props?.theme?.blue?.dark};
        }

        .btn {
          margin: 0;
        }
      }

      .addressList {
        width: 100%;
        
        .addressBox {
          cursor: pointer;
          width: 100%;
          margin: 24px 0 0 0;
          border: 1px solid ${(props) => props.theme.color.border};
          border-radius: 8px;
          padding-top: 16px;
          position: relative;
          background: ${(props) => props.theme.color.white};
          &.addressBoxSelected {
            border-color: ${(props) => props.theme.blue.dark};
          }

          .addressType {
            color: ${(props) => props.theme.blue.light};
            background: ${(props) => props.theme.blue.iconBg};
            font-size: 13px;
            font-weight: 700;
            border-radius: 8px 0;
            padding: 5px 12px;
            display: inline-block;
            position: relative;
            top: -16px;
            left: 0;
          }

          .address-selected-image{
            margin-top: 8px;
          }

          .address-selected-primary { 
            display: inline-block;
            position: relative;
            top: -16px;
            left: 0;
          }

          .address-selected { 
            display: inline-block;
            position: absolute;
            top: 0px;
            left: 0;
            right: 0;
            text-align: right;
          }

          .addressTag {
            color: ${(props) => props.theme.green.dark};
            background: ${(props) => props.theme.green.extraLight};
            font-size: 12px;
            font-weight: 600;
            border-radius: 5px;
            padding: 4px 8px;
            position: absolute;
            top: 16px;
            right: 16px;
          }

          .addressTag-popup {
            color: ${(props) => props.theme.green.dark};
            background: ${(props) => props.theme.green.extraLight};
            font-size: 12px;
            font-weight: 600;
            border-radius: 5px;
            padding: 4px 8px; 
            margin-right: 16px;
          }

          .name {
            max-width: calc(100% - 70px);
            font-size: 18px;
            font-weight: 700;
            padding: 0 15px;
            margin: 0 0 5px 0;
            display: flex;
            text-transform: capitalize;
            .form-check-label {
              font-size: 18px;
              font-weight: 700;
              text-transform: capitalize;
            }
          }

          .address {
            width: 100%;
            color: ${(props) => props.theme.text.medium};
            font-size: 15px;
            font-weight: 400;
            padding: 0 15px 0 45px;
            margin: 0 0 16px 0;
            word-break: break-all;
          }

          .address-popup {
            width: 80%;
            color: ${(props) => props.theme.text.medium};
            font-size: 15px;
            font-weight: 400;
            padding: 0 15px 0 16px;
            margin: 0 0 16px 0;
            word-break: break-all;
          }

          .actionButtons {
            width: 100%;
            display: flex;
            border-top: 1px solid ${(props) => props.theme.color.border};

            > div {
              width: 100%;

              .btn {
                font-size: 16px;
                font-weight: 600;
                height: 45px;
                background: transparent;
                border-color: transparent;
                border-radius: 0;
                border-right: 1px solid ${(props) => props.theme.color.border} !important;

                &.btn-primary {
                  color: ${(props) => props?.theme?.blue?.dark};

                  &:hover {
                    color: ${(props) => props?.theme?.blue?.dark};
                    background: transparent;
                  }

                }
                &.btn-danger {
                  color: ${(props) => props?.theme?.color?.red};

                  &:hover {
                    color: ${(props) => props?.theme?.color?.red};
                    background: transparent;
                  }

                  &:disabled {
                    background: transparent !important;
                    color: ${(props) => props?.theme?.color?.red}61 !important;
                  }
                }

                &:hover {
                  text-decoration: underline;
                }
              }

              &:first-child {
                .btn {
                  border-radius: 0 0 0 8px;
                }
              }

              &:last-child {
                .btn {
                  border: 0;
                  border-radius: 0 0 8px 0;
                }
              }
            }
          }
        }
      }

      .add-new-address-container {
        margin-left: -20px;

        .add-new-address {
          color: ${(props) => props?.theme?.colors?.primary?.blue["700"]};
          padding-left: 10px;
        }

      }
    }
  }

  .erx-tooltip{
    .upload-btn-wrapper {
      width: calc(100% - 32px);
      margin: 0 16px 16px !important
    }
    .tooltip-boxes{
      .claimFormUpload {
        .topArea {
          .tooltip{
            opacity: 1;
            transform: translate(4px,-58px) !important; 
            .tooltip-arrow {
              left: -117px !important;
              &:before{
                top: -1px;
                border-width: 1.3rem 0.9rem 0;
              }
            }
            .tooltip-inner{
              font-size: 15px;
            }
          }
        }
      }
      .diagnosticFormUpload{
        .topArea {
          .tooltip{
            opacity: 1;
            transform: translate(4px,-58px) !important; 
            .tooltip-arrow {
              left: -67.5px !important;
              &:before{
                top: -1px;
                border-width: 1.3rem 0.9rem 0;
              }
            }
            .tooltip-inner{
              font-size: 15px;
            }   
          }
        }
      }
    }
  }

  .tooltip {
    z-index: 1200;
    left: -20px;
 
    .tooltip-arrow {
      left: 20px;
      &:before {
        border-top-color: ${(props) => props?.theme?.color?.white};
      }
    }

    .tooltip-inner {
      color: ${(props) => props?.theme?.color?.black};
      background: ${(props) => props?.theme?.color?.white};
      box-shadow: 0 0 18px 0 ${(props) => props?.theme?.color?.shadow}33;
      padding: 24px 16px;
      text-align: left;
      min-width: 452px;

      .heading {
        font-weight: 700;
      }
    }
  }
  .menu-tooltip{
    .tooltip-inner{
    padding: 8px 8px;
    min-width: auto;
    }
  }

  .font-17 {
    font-size: 17px;
    line-height: 21px;
    font-weight: 500;
  }
   .create-profile-modal-text {
    font-size: 17px;
    line-height: 21px;
    font-weight: 400;
    color: ${(props) => props?.theme?.color?.icon};
  }
  .create-profile-modal{
    .modalDialogStyled{
    .modal-content{
       .modal-footer {
          button{
            width: 46%;
          }
         }
        }
      }
    }
    .customContainer {
    width: 106%;
    display: flex;
    justify-content: left;
    margin-left: 18px;
  }
  .customContainerbundle{
    width: 106%;
    display: flex;
    justify-content: left;
    margin-left: 18px;
  }
  .bundeldeal{
  .modal-footer {
      display: flex;
      flex-direction: column-reverse;
      height: auto !important;
      min-height: 92px;
      background-color: ${(props) => props?.theme?.green?.dark}; 
      box-shadow: none !important;

      .price-wrapper-bundle{
        width: 40%;
      }
      .qty-bundle-bundle{
         font-weight: 600;
         font-size: 15px;
         color:${(props) => props?.theme?.text?.medium};
      }
      .currency-label-bundle {
        font-size:18px;
        font-weight: 700;
      }
     .primaryButton-wrapper-bundle{
       width: 60%;
       margin-right: 14px
     }

      .btn.btn-primary{
        background-color: ${(props) => props?.theme?.green?.dark}; 
        border-color:green;
      }

      .btn.btn-secondary {
      background-color: transparent; 
      border: none;
      color: ${(props) => props?.theme?.green?.dark}; 
    
      }
    }
  }   
  .upsellingModal{ 
    .section_box_body{
      padding: 0px;
      .value_number{
        color: var(--light-theme-main-typography, #031A32);
        font-family: Mulish;
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 19px; 
      }
       .not_delivered_para{
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
          color: ${(props) => props?.theme?.text?.darkest};
          margin-top: 10px;
          margin-bottom:24px;
       }
       .unshipped_item_list{
         margin-bottom: 20px;
       }
    }
    .modal-footer {
      display: flex;
      flex-direction: column-reverse;
      height: auto !important;
      min-height: 92px;
      background-color: ${(props) => props?.theme?.green?.dark}; 
      box-shadow: none !important;

      .price-wrapper{
        width: 40%;
      }
      .qty{
         font-weight: 600;
         font-size: 15px;
         color:#78909C;
      }
      .currency-label {
        font-size:18px;
        font-weight: 700;
      }
     .primaryButton-wrapper{
       width: 60%;
       margin-right: 14px
     }

      .btn.btn-primary{
        background-color: ${(props) => props?.theme?.green?.dark}; 
        border-color:green;
      }

      .btn.btn-secondary {
      background-color: transparent; 
      border: none;
      color: ${(props) => props?.theme?.green?.dark}; 
    
      }
    }   
  }


  .noItemShippedModal{ 
    .section_box_body{
      padding: 0 10px;
      .value_number{
        color: var(--light-theme-main-typography, #031A32);
        font-family: Mulish;
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 19px; 
      }
       .not_delivered_para{
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
          color: ${(props) => props?.theme?.text?.darkest};
          margin-top: 10px;
          margin-bottom:24px;
       }
       .unshipped_item_list{
         margin-bottom: 20px;
       }
    }
    .modal-footer {
      display: flex;
      flex-direction: column-reverse;
      height: auto !important;
      min-height: 92px;
      background-color: ${(props) => props?.theme?.sectionBox?.bodyBg}; 
      box-shadow: none !important;

      .btn.btn-primary{
        background-color: ${(props) => props?.theme?.green?.dark}; 
      }

      .btn.btn-secondary {
      background-color: transparent; 
      border: none;
      color: ${(props) => props?.theme?.green?.dark}; 
    
      }
    }   
  }

  .sphOptionsModal {
    .sph-options-list {
      padding-top: 24px;
    }
    .sph-option-item{
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding: 18px 8px 14px 24px;
      width: 100%;
      border-bottom: 1px solid ${(props) => props?.theme?.grey?.iconBg};
      
      .form-check-label {
        margin-left: 24px;
        font-size: 16px;
      }

      .radiobutton label{
        width: calc(80vw - 50px);
       }

      .radiobutton .form-check-input[type='radio'] {
        width: 16px;
        height: 16px;
         &:checked {
            background: url(${IC_RADIO_CHECKED_GREEN.src}) no-repeat 50% 50%;
        }
      } 

      .radiobutton-selected {
        color: ${(props) => props?.theme?.green?.dark}; 
      }
    }

    .modal-footer {
      display: flex;
      flex-direction: column-reverse;
      height: auto !important;
      min-height: 92px;
      background-color: ${(props) => props?.theme?.green?.dark}; 
      box-shadow: none !important;
     
      .primaryButton-wrapper{
       width: 60%;
       margin-right: 14px
     }

      .btn.btn-primary{
        background-color: ${(props) => props?.theme?.green?.dark}; 
        border-color:green;
      }

      .btn.btn-secondary {
        background-color: transparent; 
        border: none;
        color: ${(props) => props?.theme?.green?.dark}; 
      }
    }
   }

  .select_insurance_provider{
    .content {
      padding: 24px;

      .title {
        font-size: 16px;
        font-weight: 700;
        margin: 0 0 16px 0;
        
        span {
          font-size: 14px;
          font-weight: 600;
        }
      }

      .card_wrapper {
        padding: 110px 0 90px 0;
        .btn {
          margin: 32px 0 0 0;
        }
        p {
          &.subtitle {
            max-width: 220px;
            font-size: 16px;
            margin: 0 auto;
          }
        }
      }
    }

    .modal-footer {
        .btn {
          &.btn-primary {
            background:  ${(props) => props?.theme?.green?.dark};
            border-color:  ${(props) => props?.theme?.green?.dark};
          }
        }
      }
  }

  .couponSection {
    padding: 4px 24px 24px 24px;
    .titleBar {
      .title {
        margin-left: 0;
      }
    }
  }

  .cancelOrderModal {
    .content {
      padding: 24px;
    }

    .errorArea {
      width: 100%;
      color: ${(props) => props?.theme?.color?.red};
      background: ${(props) => props?.theme?.verification?.red?.off};
      font-size: 15px;
      line-height: 19px;
      font-weight: 700;
      padding: 15px 24px;
    }

    .notes {
      color:${(props) => props?.theme?.text?.medium};
      font-size: 14px;
      font-weight: 400;

      a {
        color:${(props) => props?.theme?.green?.dark};
        font-size: 15px;
        font-weight: 700;
        padding: 0 0 0 5px;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .paidByBox {
      width: 100%;
      background: ${(props) => props?.theme?.color?.white};
      border: 1px solid ${(props) => props?.theme?.color?.lightGray};
      border-radius: 8px;
      margin: 0 0 24px 0;
      
      .titleArea {
        display: flex;
        align-items: center;
        padding: 16px;
        border-bottom: 1px solid ${(props) => props?.theme?.color?.lightGray};

        .icon {
          display: flex;
          margin: 0 15px 0 0;
        }
        .title {
          font-size: 16px;
          font-weight: 600;
        }
      }

      .contentArea {
        background: ${(props) => props?.theme?.green?.off};
        border-radius: 0 0 8px 8px;
        padding: 20px 24px 20px 16px;
        display: flex;
        align-items: center;

        .label {
          color: ${(props) => props?.theme?.grey?.dark};
          font-size: 15px;
          font-weight: 600;
          span {
            color: ${(props) => props?.theme?.color?.red};
          }
        }

        .price {
          font-size: 18px;
          font-weight: 700;
          margin-left: auto;
        }
      }
    }

    .accordion {
      margin: 0 0 24px 0;

      .accordion-item {
        border: 1px solid ${(props) => props?.theme?.color?.lightGray};
        border-radius:8px;
      }
      .accordion-header {
        .accordion-button {
          background: white;
          border-bottom: 1px solid ${(props) => props?.theme?.color?.lightGray};
          box-shadow: 0 0 0;
          border-radius: 8px 8px 0 0;

          .leftArea {
            display: flex;
            align-items: center;
  
            .icon {
              width: 35px;
              height: 35px;
              margin: 0 16px 0 0;
            }
  
            .title {
              color: ${(props) => props?.theme?.text?.dark};
              font-size: 17px;
              font-weight: 700;
            }
          }
          .rightArea {
            margin-left: auto;
  
            .totalItems {
              color: ${(props) => props?.theme?.text?.medium};
              font-size: 14px;
              font-weight: 600;
            }
          }

          &:focus {
            outline: none;
            box-shadow: 0 0 0;
          }
          &::after {
            display: none;
          }
        }
      }
      .accordion-body {
        padding: 0;

        .selectAllRow {
          background: ${(props) => props?.theme?.blue?.extraLight};
          border-bottom: 1px solid ${(props) => props?.theme?.color?.lightGray};
          padding: 12px 24px;

          .form-check {
            .form-check-label {
              color: ${(props) => props?.theme?.text?.dark};
              font-size: 14px;
              font-weight: 700;
            }
          }
        }

        .itemListing {
          width: 100%;
          padding: 0 24px;
          
          .listBox {
            width: 100%;
            padding: 16px 0;
            margin: 0 0 16px 0;
            border-bottom: 1px solid ${(props) => props?.theme?.color?.lightGray};
            display: flex;
            flex-direction: row;

            .leftSection {
              display: flex;
              flex-direction: row;
              align-items: center;

              .form-check-input {
                margin: 0 20px 0 0;
              }

              .productPic {
                min-width: 70px;
                width: 70px;
                height: 70px;
                border: 1px solid ${(props) => props?.theme?.color?.divider};
                border-radius: 8px;
                margin: 0 12px 0 0;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .prodDetails {
                height: 100%;
                padding-right: 16px;
                display: flex;
                flex-direction: column;

                .prodName {
                  color: ${(props) => props?.theme?.text?.darkest};
                  font-size: 16px;
                  font-weight: 600;
                  margin: 0 0 8px 0;
                  word-break: break-all;
                }
                
                .prodQty {
                  color: ${(props) => props?.theme?.text?.medium};
                  font-size: 13px;
                  font-weight: 700;
                }
              }
            }

            .rightSection {
              margin-left: auto;

              .price {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                white-space:nowrap;
                .new {
                  font-size: 16px;
                  font-weight: 700;
                  margin: 0 0 4px 0;
                }
                .actual {
                  color: ${(props) => props?.theme?.text?.medium};
                  font-size: 12px;
                  font-weight: 700;
                  text-decoration: line-through;
                }
              }
            }
            &:last-child {
              margin: 0;
              border-bottom: 0;
            }
          }

          .dropdown {
            .dropdown-toggle {
              font-size: 16px;
              color: ${(props) => props?.theme?.text?.medium};
            }
          }
        }
      }
    }

    .btn {
      color: ${(props) => props?.theme?.color?.white};
      font-weight: 700;
      background: ${(props) => props?.theme?.green?.dark};
      border-color: ${(props) => props?.theme?.green?.dark};

      &:hover {
        background: ${(props) => props?.theme?.green?.light};
        border-color: ${(props) => props?.theme?.green?.light};
      }
    }
    .btn-secondary {
      color: ${(props) => props?.theme?.green?.dark};
      background: ${(props) => props?.theme?.color?.white};

      &:hover {
        color: ${(props) => props?.theme?.color?.white};
        background: ${(props) => props?.theme?.green?.dark};
      }
    }
  }
.right-bar-modal-prescription{
  .rightBarDialogStyled {
    .modal-content{
      .btn-close:before {
        opacity:0;
      }
      .btn-close:after {
        border-left: 1px solid ${(props) => props?.theme?.color?.divider};
      }
      .modal-header{
        border-bottom-color: transparent;
        background-color: ${(props) => props?.theme?.sectionBox?.bodyBg};
      }
      .modal-footer{
        box-shadow: unset;
        button{
          color:${(props) => props?.theme?.blue?.dark};
          background: transparent;
          border-color: transparent;
        }
      }
      .modal-body {
       .right-bar-common-space-holder{
         padding: 0 16px 16px;
          .card_wrapper{
            padding: 0;
            background: transparent;
            .subtitle{
              font-weight: 400;
              font-size: 15px;
              color:${(props) => props.theme.text.darkest};
            }
          }
        }
        .right-section-bar{
          background: ${(props) => props.theme.color.white};
          min-height: calc(100vh - 480px);
          .container::before{
              background: linear-gradient(180deg,${(props) =>
    props.theme.sectionBox.gradientStart} 5%, rgba(255, 255, 255, 0.8) 100%);
          }
          .number-section-wrapper{
            display: flex;
            align-items: center;
            background:${(props) => props.theme.blue.iconBg};
            border-radius: 8px;
            padding: 12px;
            font-weight: 500;
            font-size: 15px;
            line-height: 19px;
            margin: 0px 0 16px 0px;
              .number-style{
                font-weight: 600;
                width: 34px;
                min-width: 34px;
                height: 34px;
                background: ${(props) => props.theme.color.white};
                box-shadow: 0px 4px 4px rgb(25 118 210 / 8%);
                border-radius: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right:15px;
                color:${(props) => props.theme.blue.dark};
              }
            }
        }
      }
    } 
  }
}
.failed-order-wrapper{
  .rightBarDialogStyled {
    .modal-content{
      background-color: ${(props) => props?.theme?.sectionBox?.bodyBg};
      .btn-close:after {
        border-left: 1px solid ${(props) => props?.theme?.color?.divider};
      }
      .modal-header{
        background-color: ${(props) => props?.theme?.color?.white};
        border-bottom-color: ${(props) => props?.theme?.color?.divider};
        box-shadow: 0px 4px 7px 0px ${(props) => props?.theme?.color?.white};
      }
      .modal-body{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
      .modal-footer{
        box-shadow: unset;
        button{
          background:${(props) => props?.theme?.blue?.dark};
          color: ${(props) => props?.theme?.color?.white};
          border-color: transparent;
        }
      }
    }
  }
}


.add_insurance_modal{
  .titleWithHelp{
    display:flex;
    justify-content:space-between;
    max-width:calc(100% - 50px);
  }
  .insuranceProfile{
    border-radius:0;
    border:0;
    border-bottom:1px solid  ${(props) => props?.theme?.color?.divider}; 

    .insuranceTitle{
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: ${(props) => props?.theme?.text?.medium};
      margin-bottom:19px;
    }
    .profilePic{
      margin-right:14px;
      border-radius:51px;
      width:51px;
      height:51px;
      overflow:hidden;
      border:1px solid  ${(props) => props?.theme?.color?.divider}; 
    }
    .profileName{
      font-weight: 700;
      font-size: 18px;
      line-height: 23px;
      color: ${(props) => props?.theme?.text?.dark};
    }
  }

  .insurance-method {
    opacity: 0.8;
    background: linear-gradient(180deg, #F1F6FB 0%, rgba(255, 255, 255, 0.00) 100%);

    .invalid-feedback {
      font-size: 16px;
    }

    .dropdown-wrapper {
      align-items: baseline;
    }

    .form-select {
      min-height: 58px !important;
      background: none;
      color: ${(props) => props?.theme?.text?.medium};
    }

    .nativeSelect::before {
      top: 20px !important;
    }

    .tab-wrapper {
      margin-top: 12px;
      margin-bottom: 0rem !important;
    }

    .emirates-ID {
      font-family: Mulish;
      font-size: 13px;
      font-weight: 600;
      line-height: 16px;
      color: ${(props) => props?.theme?.text?.medium};
      margin-top: 16px;

      .inputField {
        color: ${(props) => props?.theme?.grey?.dark};
      }
    }

    .insurance-id-field {
      margin-top: 10px;
    }

    .date-picker-insurance {
      margin-top: 24px;
      position: relative;
    }

    .date-picker-emirates {
      margin-top: 15px;
      position: relative;
    }

    .checkoutbox-insurance {
      margin-top: 130px;
    }

    .checkoutbox-emirates {
      margin-top: 190px;
    }

    .checkoutbox-wrapper {
      .add-insurance-checkbox-wrapper {
        position: relative;
        display: flex;
    
        .add-insurance-checkbox {
          .form-check {
            label {
              max-width: 100%;
            }
          }
          .invalid-feedback {
            position: absolute;
            margin-top: 15px;
          }
          .form-check .form-check-input[type='checkbox'] {
            width: 22px;
            height: 22px;
            margin-top: 10px;
          }
        }
      }
      .add-insurance-consent-form {
        font-weight: 600;
        font-size: 14px;
        color: ${(props) => props.theme.blue.dark};
        cursor: pointer;
      }
      .add-insurance-grey-text {
        font-weight: 600;
        color: ${(props) => props.theme.text.medium};
      }

    }
  }


  .img-sub-title {
    font-weight: 600;
    font-size: 13px;
    color: ${(props) => props.theme.text.medium};
  }
  .upload-wrapper{
    min-height:118px !important;
  }
  .upload-image{
    .d-flex{
      flex-direction:column;

      .text-title{
        margin-left:0;
        margin-top:10px;
      }
    }
  }
  .text-or-title{
    display:none;
  }
}

  .defaultInsuranceModal{
    .consentText {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: ${(props) => props?.theme?.text?.medium};
    }
    .edit-radio-btn {
      .form-check-input[type='radio']:checked + label {
        color: ${(props) => props?.theme?.blue?.dark};
      }
    }
    .insuranceCount{
      font-weight: 700;
      font-size: 16px;
      margin:24px 0;

      .lightFont{
        font-weight: 600;
        font-size: 14px;
      }
    }
    .insuranceCard{
      background: ${(props) => props?.theme?.blue?.extraLight};
      border: 1px solid ${(props) => props?.theme?.color?.borderLight};
      border-radius: 8px;
      margin-bottom:16px;

      .defaultInsurance{
        background: ${(props) => props?.theme?.blue?.iconBg};
        border-radius: 7px 0px;
        padding: 5px 12px;
        display:inline-block;
        font-weight: 700;
        font-size: 13px;
        line-height: 16px;
        color:  ${(props) => props?.theme?.blue?.light};
      }

      .cardContent{
        padding:16px;

        .insurance-calendar-wrapper {
          padding: 0px;
    
          .insurance-text-orange {
            display: flex;
            flex-direction: row;
            background: ${(props) => props?.theme?.yellow?.off};
            padding: 8px 16px;
            min-height: 53px;
            gap: 8px;
            border-radius: 8px;

            .insuranceCalendar {
              padding-top: 5px;
            }
    
            .insurance-status {
              color: ${(props) => props?.theme?.text?.medium};
              font-size: 12px;
              font-weight: 600;
              line-height: 16px;
            }
          }
        }

        .providerName{
          font-weight: 600;
          font-size: 16px;
          line-height: 20px;
          color: ${(props) => props?.theme?.text?.darkest};
          margin-bottom: 8px;
        }

        .providerId{
          font-weight: 600;
          font-size: 13px;
          line-height: 16px;
          color: ${(props) => props?.theme?.text?.medium};
          margin-bottom: 8px;
        }

        .providerCover{
          font-weight: 600;
          font-size: 14px;
          line-height: 18px;
          

          &.green{
            color: ${(props) => props?.theme?.green?.dark};
          }
          &.red{
            color: ${(props) => props?.theme?.color?.red};
          }
        }
        .providerFooter{
          display: flex;
          justify-content: space-between;
          align-items:center;
          margin-top: 32px;

          .status {
            padding: 6px 12px;
            border-radius: 8px;
            background: ${(props) => props.theme.color.divider};
            color: ${(props) => props.theme.text.medium};
            font-weight: 600;
            font-size: 14px;
            line-height: 18px;
        
            &.pending {
              background: ${(props) => props.theme.text.pending}20 url(${IC_PENDING.src}) no-repeat 10px 8px / 15px;
              color: ${(props) => props.theme.verification.orange.main};
              padding-left: 34px;
            }
            &.expired {
              background: ${(props) => props.theme.color.red}20 url(${IC_INCOMPLETE.src}) no-repeat 10px 8px / 15px;
              padding-left: 34px;
              color: ${(props) => props.theme.verification.red.main};
            }
            &.valid {
              background: ${(props) => props.theme.green.off} url(${IC_VERIFIED.src}) no-repeat 10px 8px / 15px;
              color: ${(props) => props.theme.verification.green.main};
              padding-left: 34px;
            }
          }

          .expiryLabel{
            font-weight: 600;
            font-size: 13px;
            line-height: 16px;
            color: ${(props) => props.theme.text.light};
          }
          .expiryDate{
            font-weight: 600;
            font-size: 15px;
            line-height: 19px;
            color: ${(props) => props.theme.text.darkest};
          }
        }
      }
    }
    &.addFamilyModal{
      .titleBar{
        display:none;
      }
      .blank-card-overflow-unset{
        border:0;
      }
      .form-check{
        align-items:center;
      }
      .paddingBox {
        width: 100%;
        padding: 24px;
      }
    
      @media (max-width: 767px) {
        .mobile-profile-pic {
          text-align: center;
          .profile-wrapper {
            width: 105px;
            margin: 0 auto;
          }
        }
      }
    }
  }
  .selectProfileModal{
    .defaultMessage{
      padding: 16px 24px;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: ${(props) => props.theme.text.dark};
      background: ${(props) => props.theme.blue.iconBg};
      margin-bottom:8px;
    }
    .selectProfileList{
     padding:0 24px;

     .hidden {
        visibility: hidden;
     }

    .profileItem{
       display:flex;
       padding:12px 32px 12px 12px;
       background-color: ${(props) => props.theme.color.white};
       border: 1px solid ${(props) => props.theme.color.borderLight};
       border-radius: 8px;
       margin-top: 16px;

       .profileImage{
         width:49px;
         height:49px;
         border-radius: 50%;
         margin-right:13px;
         overflow:hidden;

         div{
           display:block !important;
         }
       }
       .avtarName{
         width:49px;
         height:49px;
         font-size:22px;
         margin-right:13px;
       }
       .profileName{
         font-weight: 700;
         font-size: 16px;
         line-height: 20px;
         color: ${(props) => props.theme.text.dark};
         margin-bottom:2px;
       }
       .profileRelation{
         font-weight: 600;
         font-size: 14px;
         line-height: 18px;
         color: ${(props) => props.theme.text.medium};
         margin-bottom:7px;
       }
       .checkIcon{
         display:none;
       }

       &.selected{
         border-color: ${(props) => props.theme.blue.dark};
         position:relative;

         .checkIcon{
           display:block;
           position:absolute;
           top:0;
           right:0;
           z-index:1;
         }
       }
     }
     &:last-child{
       padding-bottom:16px;
     }
   }
 }

  .selectFacilityModal{
    .selectFacilityList{
      padding:0 24px;

      .facilityItem{
        display:flex;
        align-items:center;
        padding:12px 32px 12px 12px;
        background-color: ${(props) => props.theme.color.white};
        border: 1px solid ${(props) => props.theme.color.borderLight};
        border-radius: 8px;
        margin-top: 16px;

        .facilityImage{
          border-radius: 8px;
          margin-right:13px;
          overflow:hidden;
          min-width:72px;

          div{
            display:block !important;
          }
        }
        .facilityName{
          font-weight: 700;
          font-size: 14px;
          line-height: 20px;
          color: ${(props) => props.theme.text.dark};
          margin-bottom:5px;
        }
        .facilityDistance{
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          color: ${(props) => props.theme.text.medium};
        }
        .checkIcon{
          display:none;
        }

        &.selected{
          border-color: ${(props) => props.theme.blue.dark};
          position:relative;

          .checkIcon{
            display:block;
            position:absolute;
            top:0;
            right:0;
            z-index:1;
          }
        }
      }
      &:last-child{
        padding-bottom:16px;
      }
    }
  }

  .selectProfileModal{
    .selectProfileList{
      padding:0 24px;

      .profileItem{
        display:flex;
        padding:12px 32px 12px 12px;
        background-color: ${(props) => props.theme.color.white};
        border: 1px solid ${(props) => props.theme.color.borderLight};
        border-radius: 8px;
        margin-top: 16px;

        .profileImage{
          width:49px;
          height:49px;
          border-radius: 50%;
          margin-right:13px;
          overflow:hidden;

          div{
            display:block !important;
          }
        }
        .profileName{
          font-weight: 700;
          font-size: 16px;
          line-height: 20px;
          color: ${(props) => props.theme.text.dark};
          margin-bottom:2px;
        }
        .profileRelation{
          font-weight: 600;
          font-size: 14px;
          line-height: 18px;
          color: ${(props) => props.theme.text.medium};
          margin-bottom:7px;
        }
        .checkIcon{
          display:none;
        }

        &.selected{
          border-color: ${(props) => props.theme.blue.dark};
          position:relative;

          .checkIcon{
            display:block;
            position:absolute;
            top:0;
            right:0;
            z-index:1;
          }
        }
      }
      &:last-child{
        padding-bottom:16px;
      }
    }
  }

  .deliveryAddressModal{
    .actionBlock{
      display:flex;
      width:100%;
      justify-content:space-between;
      align-items:center;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: ${(props) => props.theme.text.darkest};
      padding:24px 18px 8px;


      .change {
        padding: 0;
        margin: 0;
        font-weight: 700;
        font-size: 15px;
        line-height: 19px;
        color: ${(props) => props.theme.blue.dark};
        background: transparent;
        border: 0;
        text-decoration: none;
        white-space: nowrap;
      }
    }
    .addressList {
      width: 100%;
      margin: 16px 0;
      padding: 0 16px;

      .addressBox{
        cursor: pointer;
        width: 100%;
        margin: 0 0 15px 0;
        border: 1px solid ${(props) => props.theme.color.border};
        border-radius: 8px;
        padding-top: 18px;
        position: relative;
        background: ${(props) => props.theme.color.white};

        .addressTag {
          color: ${(props) => props.theme.blue.light};
          background: ${(props) => props.theme.blue.iconBg};
          font-size: 12px;
          font-weight: 600;
          border-radius: 5px;
          padding: 4px 8px;
          position: absolute;
          top: 16px;
          right: 16px;
        }

        .addressTag-popup {
          color: ${(props) => props.theme.blue.light};
          background: ${(props) => props.theme.blue.iconBg};
          font-size: 12px;
          font-weight: 600;
          border-radius: 5px;
          padding: 4px 8px;
        }

        .name {
          width: 100%;
          font-size: 18px;
          font-weight: 700;
          padding: 0 15px;
          margin: 0 0 5px 0;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          text-transform: capitalize;
        }

        .address {
          width: 100%;
          color: ${(props) => props.theme.text.medium};
          font-size: 15px;
          font-weight: 400;
          padding: 0 15px 0 15px;
          margin: 0 0 16px 0;
        }

        .address-popup {
          width: 100%;
          color: ${(props) => props.theme.text.medium};
          font-size: 15px;
          font-weight: 400;
          padding: 0 15px 0 15px;
          margin: 0 0 16px 0;
        }

        .addressDetails {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .nameAndAddress {
            width: 100%;
            max-width: 570px;
          }
        }
      }
      .addAddressBox {
        width: 100%;
        margin: 0 0 15px 0;
        padding: 24px;
        border: 1px solid ${(props) => props.theme.color.border};
        border-radius: 8px;
        padding-top: 18px;
        position: relative;
        background: ${(props) => props.theme.color.white};
        text-align:center;

        .addText{
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          text-align: center;
          color: ${(props) => props.theme.grey.dark};
          margin-bottom:20px;
        }
      }
    }
  }

.edit-profile-modal-text-wrapper{
    display: flex;
    justify-content: space-evenly;
    margin-top: 24px;
    padding: 15px;
    border: 1px solid ${(props) => props.theme.color.borderLight};
    border-radius: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;  
    color: ${(props) => props.theme.text.medium};
    flex-wrap: wrap;
    .image-wrapper{
      align-items: center;
      display: flex;
      .img-text-wrapper{
        padding-left:10px;
      }
  }
}
  .selectSlotModal{
    .modal-content{ 
      .modal-body {
        background:${(props) => props.theme.color.white} !important;
      }
    }
    .switchProfileBlock {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px;
      border: 1px solid ${(props) => props.theme.color.lightGray};
      border-radius: 8px;
      &.switchProfileBlockColumn{
      flex-direction: column;
      padding: 0;
      .tostControl{
      .red-box{
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
     align-items: center;
    .img-wrapper{
    > div{
    min-width:18px;
        }
      }
    }
  }
 }
  
      .patientDetails {
        display: flex;
        align-items: center;
        margin: 0;

        .profilePic {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 10px 0 0;

          > div,
          > img {
            max-width: 100%;
          }
        }
        .profileImage {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 13px;
          overflow: hidden;

          div {
            display: block !important;
          }
        }
        .patientInfo {
          display: flex;
          flex-direction: column;
          
          .patientTitle{
            font-weight: 600;
            font-size: 15px;
            line-height: 19px;
            color: ${(props) => props.theme.text.medium};
            margin-bottom:2px;
          }
          .profileName {
            font-weight: 700;
            font-size: 17px;
            line-height: 23px;
            color: ${(props) => props?.theme?.text?.dark};
          }
        }   
      }
      .change {
        padding: 8px 11px;
        margin: 0;
        font-weight: 700;
        font-size: 15px;
        line-height: 19px;
        color: ${(props) => props.theme.blue.dark};
        background: transparent;
        border: 0;
      }
    }
    .facilityDetails{
      padding:16px 0;
      border-bottom: 1px solid ${(props) => props.theme.color.lightGray};

      .consultDesc{
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        color: ${(props) => props.theme.text.dark};
        margin-bottom:8px;

        .green{
          color: ${(props) => props.theme.green.dark};
        }
        .blue{
          color: ${(props) => props.theme.blue.dark};
        }
      }
      .facilityName{
        font-weight: 700;
        font-size: 17px;
        line-height: 21px;
        margin-bottom:6px;
        color: ${(props) => props.theme.grey.dark};
      }
      .facilityLocation{
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: ${(props) => props.theme.blue.dark};
        display:inline-flex;
        align-items:center;
        cursor:pointer;
      }
    }
    .simplebar-track.simplebar-vertical {
      width: 6px;
    }
    .simplebar-scrollbar:before {
      background: ${(props) => props.theme.blue.grey};
    }
    .simplebar-scrollbar.simplebar-visible:before {
      opacity: 1;
    }
    .dateSlotWrapper {
      padding: 0 16px;
  
      .dateWrapper {
        padding: 24px 0;
  
        .dateTitle {
          font-weight: 700;
          font-size: 17px;
          line-height: 21px;
          color: ${(props) => props.theme.text.dark};
        }
      }
      .slotWrapper {
        .slotDate {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          font-weight: 700;
          font-size: 17px;
          line-height: 21px;
          color: ${(props) => props.theme.grey.dark};
          margin-bottom: 30px;
  
          .insuranceLabel {
            color: ${(props) => props.theme.text.medium};
            font-weight: 700;
            font-size: 14px;
            line-height: 18px;
            display: flex;
            align-items: center;
  
            .greenDot {
              background: ${(props) => props.theme.green.light};
              width: 5px;
              height: 5px;
              border-radius: 50%;
              display: block;
              margin: 0px 4px;
            }
          }
        }
        .slotList {
          margin-bottom: 30px;
  
          .slotTime {
            font-family: 'Mulish';
            font-weight: 700;
            font-size: 16px;
            line-height: 18px;
            color: ${(props) => props.theme.bookingPage.slotTime};
            margin-bottom: 10px;
          }
          .slots {
            display: flex;
            gap: 16px;
            vertical-gap: 16px;
            flex-wrap: wrap;
  
            .slot {
              font-family: 'Mulish';
              padding: 11px 0px;
              min-width: calc(25% - 12px);
              cursor: pointer;
              position: relative;
              background: ${(props) => props.theme.color.white};
              border: 1px solid ${(props) => props.theme.color.border};
              border-radius: 8px;
              font-weight: 600;
              font-size: 14px;
              line-height: 18px;
              color: ${(props) => props.theme.text.dark};
              text-align: center;
  
              &.active {
                color: ${(props) => props.theme.color.white};
                border-color: ${(props) => props.theme.blue.dark};
                background-color: ${(props) => props.theme.blue.dark};
              }
              &.disabled {
                color: ${(props) => props.theme.text.medium};
                border-color: ${(props) => props.theme.color.lightGray};
                background-color: ${(props) => props.theme.blue.extraLight};
              }
              &.covered {
                ::after {
                  content: '';
                  width: 5px;
                  height: 5px;
                  position: absolute;
                  left: calc(50% - 2px);
                  bottom: 6px;
                  background-color: ${(props) => props.theme.green.light};
                  border-radius: 5px;
                }
              }
            }
          }
        }
        .noSlotFound {
          display: flex;
          justify-content: center;
          flex-direction: column;
          padding-bottom: 100px;
        }
      }
    }
    .buttonWrapper {
      width:100%;
      z-index: 2;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 15px;
      line-height: 19px;
      color: ${(props) => props.theme.text.dark};
      margin: 0;

      .slotDetails {
        flex-grow: 1;
        .day {
          font-weight: 700;
          font-size: 11px;
          line-height: 16px;
          color: ${(props) => props.theme.text.medium};
        }
        .timeDate {
          font-weight: 700;
          font-size: 18px;
          line-height: 23px;
          color: ${(props) => props.theme.text.dark};
          margin-bottom: 3px;

          > span {
            color: ${(props) => props.theme.grey.dark};
          }
        }
        .inPerson {
          font-weight: 700;
          font-size: 12px;
          line-height: 16px;
          color: ${(props) => props.theme.green.dark};
          display: flex;
          align-items: center;
        }
        .videoConsult {
          font-weight: 700;
          font-size: 12px;
          line-height: 16px;
          color: ${(props) => props.theme.blue.dark};
          display: flex;
          align-items: center;
        }
      }

      .bookingBtn {
        padding: 18px 34px;
        font-weight: 700;
        font-size: 17px;
        line-height: 21px;
        white-space: nowrap;
        margin: 0;
        flex-grow:1;

        @media (max-width: 767px) {
          padding: 20px 15px;
        }
      }
    }
  }
  

  .red-border {
    .dropdown-toggle{
      border-color: ${(props) => props.theme.verification.red.main} !important;
      border-radius: 8px;
    }
  }

  .date-picker-input {
    .calendar-top {
      &.react-calendar {
        position: absolute;
        top: -283px;
        z-index: 100;
      }
    }
  }

  .green-small-dot {
    background: ${(props) => props.theme.green.light};
    width: 5.4px;
    height: 5px;
    border-radius: 50%;
    position: absolute;
    bottom: 4px;
    left: 50%;
    right: 50%;
  }

  .insuranceCovered {
    .insuranceLabel {
      color: ${(props) => props.theme.text.medium};
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      display: flex;
      align-items: center;

      .greenDot {
        background: ${(props) => props.theme.green.light};
        width: 5px;
        height: 5px;
        border-radius: 50%;
        display: block;
        margin: 0px 4px;
      }
    }
  }
  .orderFeedbackModal{
    .modal-footer{
      flex-direction:row-reverse;
      gap:13px;

      .btn.btn-primary{
        font-size:17px;
        line-height:20px;
        background: ${(props) => props.theme.green.dark};
        border-color: ${(props) => props.theme.green.dark};
        padding:0 18px; 
        margin:0;
        height:56px;
        min-width:60%;
        flex-grow:1;
      }
      .btn.btn-secondary{
        font-size:17px;
        line-height:20px;
        background:${(props) => props.theme.color.white};
        color: ${(props) => props.theme.green.dark};
        border-color: ${(props) => props.theme.green.dark};
        padding:0 18px; 
        margin:0;
        height:56px;
        flex-grow:1;
      }
    }
  }

  .consentRequiredModal{
    &.modal{
      .modalDialogStyled{
        .modal-content{
          .homecare.modal-body {
            padding: 25px 35px 0 35px;
          }
          .Consent-Form{
            display:flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            .fileName{
              display:flex;
              max-width:calc(100% - 95px);
              cursor : pointer !important;

              .icon {
              display:flex;
              min-width:24px;
              > div{
                display: block !important;
              }
              }
              .name{
                overflow:hidden;
                white-space:nowrap;
                text-overflow:ellipsis;
                width:100%;
                color : ${(props) => props?.theme?.royalBlue?.DarkBlueGray} !important;
              }
            }
            .downloadBtn{
              white-space:nowrap;
              margin-left:10px;
              color : ${(props) => props?.theme?.royalBlue?.darkestBlue} !important;
              cursor : pointer !important;
            }
          }
          .homecare.modal-footer {
            padding: 30px;
          }
          .modal-footer{
            .btn:last-child{
              padding:0;
            }
            .btn {
               &.btn-primary {
              cursor : default !important;
              }
            }
            .btn-secondary.homecare.consentForm {
              margin-top: 1.5rem !important;
            }
          }
        }
      }
    }    
  }

  .confirm-modal {
    &.switchProfileBlock {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      padding: 16px;
      border: 1px solid ${(props) => props.theme.color.lightGray};
      border-radius: 6px;
  
      .h-line {
        border: 1px solid ${(props) => props.theme.color.lightGray};
        width: 100%;
      }
      .change {
        padding: 8px 11px;
        margin: 0;
        font-weight: 700;
        font-size: 15px;
        line-height: 19px;
        color: ${(props) => props.theme.text.lightBlue};
        background: transparent;
        border: 0;
  
        &:hover {
          background-color: ${(props) => props.theme.text.lightBlue};
          color: ${(props) => props.theme.color.white};
        }
      }
  
      .patientDetails {
        display: flex;
        align-items: center;
  
        .profilePic {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 10px 0 0;
  
          > div,
          > img {
            max-width: 100%;
          }
        }
        .profileImage {
          width: 49px;
          height: 49px;
          min-width:49px;
          border-radius: 50%;
          margin-right: 13px;
          overflow: hidden;
  
          div {
            display: block !important;

            &.avtar {
              display: flex !important;
              padding: 0;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .patientInfo {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .label {
            min-width: 1px;
            font-size: 13px;
            font-weight: 600;
            color: ${(props) => props.theme.text.medium};
          }
          .value {
            font-size: 15px;
            font-weight: 600;
          }
          .profileName {
            font-weight: 700;
            font-size: 17px;
            line-height: 23px;
            color: ${(props) => props?.theme?.text?.dark};
            word-break:break-all;
            text-align:left;
          }
          .patientTitle{
            color: ${(props) => props.theme.text.medium};
            font-family: Mulish;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 18px;
          }
        }
        
        .avtar {
          background: ${(props) => props.theme.blue.grey};
          color: ${(props) => props.theme.color.white};
          height: -webkit-fill-available;
          font-size: 20px;
          padding: 8px 0px 0px 12px;
        }
      }

      .t-title {
        font-family: 'Mulish';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        color: ${(props) => props?.theme?.text?.dark};
        margin: 0 0 0 0;
      }
    
      .t-subtitle {
        font-family: 'Mulish';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 19px;
        color: ${(props) => props?.theme?.text?.medium};
        text-align: center;
        margin: 16px 0 0 0;
        text-align: start;
      }
    }
  }
  .showCartModal {
    position:fixed;
   
    &.modal {
      .modalDialogStyled {
        .modal-content {
          .modal-body {
            padding: 0;
          }

          @media(max-width:576px){
            margin-bottom:40px;
          }
        }
      }
    }
    .modal-dialog {
      margin: 2rem 22px 22px auto;
      max-width: 480px;

      @media(max-width:576px){
        margin: 2rem 15px 22px auto;
        width:100%;
        max-width: 100%;
        padding:0 15px;
      }

      .dot-loader{
          position:absolute;
          top:60px;
          bottom:78px;
          left:0;
          right:0;
          display:flex;
          justify-content:center;
          align-items:center;
          z-index:2;
          background: rgba(255,255,255,0.3);
        }

        .dot-pulse {
          position: relative;
          left: -9999px;
          width: 15px;
          height: 15px;
          border-radius: 8px;
          background-color: ${(props) => props.theme.royalBlue.lightGrey};
          color: ${(props) => props.theme.royalBlue.lightGrey};
          box-shadow: 9999px 0 0 0px;
          animation: dot-pulse 1.5s infinite linear;
          animation-delay: 0.25s;
          z-index:2;
        }
        .dot-pulse::before, .dot-pulse::after {
          content: "";
          display: inline-block;
          position: absolute;
          top: 0;
          width: 15px;
          height: 15px;
          border-radius: 8px;
          background-color: ${(props) => props.theme.royalBlue.lightGrey};
          color: ${(props) => props.theme.royalBlue.lightGrey};
        }
        .dot-pulse::before {
          box-shadow: 9954px 0 0 0px;
          animation: dot-pulse-before 1.5s infinite linear;
          animation-delay: 0s;
        }
        .dot-pulse::after {
          box-shadow: 10044px 0 0 0px;
          animation: dot-pulse-after 1.5s infinite linear;
          animation-delay: 0.5s;
        }

        @keyframes dot-pulse-before {
          0% {
            box-shadow: 9954px 0 0 0px;
          }
          30% {
            box-shadow: 9954px 0 0 15px;
          }
          60%, 100% {
            box-shadow: 9954px 0 0 0px;
          }
        }
        @keyframes dot-pulse {
          0% {
            box-shadow: 9999px 0 0 0px;
          }
          30% {
            box-shadow: 9999px 0 0 15px;
          }
          60%, 100% {
            box-shadow: 9999px 0 0 0px;
          }
        }
        @keyframes dot-pulse-after {
          0% {
            box-shadow: 10044px 0 0 0px;
          }
          30% {
            box-shadow: 10044px 0 0 15px;
          }
          60%, 100% {
            box-shadow: 10044px 0 0 0px;
          }
        }

      .modalHeader {
        display: flex;
        align-items: center;
        border-bottom: 1px solid ${(props) => props.theme.color.borderLight};
        justify-content: space-between;
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        color: ${(props) => props.theme.color.black};
        padding: 0 16px;
        border-radius: 8px 8px 0px 0px;

        .closeBtn {
          border: 0;
          border-left: 1px solid ${(props) => props.theme.color.borderLight};
          padding: 16px 5px 16px 21px;
          background: transparent;
        }
      }
      .modalBody {
        height: 230px;
        max-height: 230px;
        overflow: auto;
        padding: 0 16px;
        position:relative;

       

        &.noItem {
          height: 306px;
          max-height: 306px;
        }
        .cartItemList {
          .serviceItem {
            position: relative;
            border-bottom: 1px solid ${(props) => props.theme.color.borderLight};
            padding: 16px 0;

            .actionBlock {
              position: absolute;
              right: 0;
              bottom: 16px;
              > div {
                &:last-child {
                  display: none;
                }

                button {
                  margin-right: 0;
                  min-width: 15px !important;

                  .left {
                    margin-right: 0;
                  }
                  > div {
                    &:last-child {
                      display: none;
                    }
                  }
                }
              }
            }
          }
          > div:last-child{
            .serviceItem {
              border-bottom:0;
            }
          }
        }

        .exploreServiceBlock {
          text-align: center;
          padding: 68px 85px 0;


          @media(max-width:576px){
            padding: 68px 0px 0;
          }

          .exploreText {
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            color: ${(props) => props.theme.text.medium};
            margin-bottom: 24px;
          }
        }
      }
      .modalFooter {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        box-shadow: 0px -4px 7px rgba(44, 62, 112, 0.08);
        border-radius: 0px 0px 8px 8px;
        gap: 8px;

        .itemDetail {
          min-width: 124px;
          .itemCount {
            font-weight: 500;
            font-size: 14px;
            line-height: 18px;
            color: ${(props) => props.theme.text.light};
            margin-bottom: 2px;
          }
          .itemTotal {
            font-weight: 700;
            font-size: 16px;
            line-height: 20px;
            color: ${(props) => props.theme.text.dark};
          }
        }
      }
    }

    .modal-dialog-centered {
      align-items: flex-end;
    }
  }

  .homecareLoginModal{
    &.btn-secondary{
      background-color: ${(props) => props.theme.royalBlue.off};
      color: ${(props) => props?.theme?.royalBlue?.dark};

      &:hover{
        background-color: ${(props) => props.theme.royalBlue.off};
        color: ${(props) => props?.theme?.royalBlue?.dark};
      }
    }
    &.btn-primary{
      color: ${(props) => props?.theme?.color?.white};
      background-color: ${(props) => props.theme?.blue?.royal};
      border-color:${(props) => props.theme?.blue?.royal};
      &:hover{
        color: ${(props) => props?.theme?.color?.white};
        background-color: ${(props) => props?.theme?.royalBlue?.dark};
        border-color: ${(props) => props?.theme?.royalBlue?.dark};
      }
    }
  }

  .paymentModal{

 
    .btn-primary{
      color: ${(props) => props.theme.royalBlue.off};
      background-color:${(props) => props.theme.text.lightBlue};
      border-color:${(props) => props.theme.text.lightBlue};
      &:hover{
        color: ${(props) => props.theme.royalBlue.off};
        background-color:${(props) => props.theme.text.lightBlue};
        border-color:${(props) => props.theme.text.lightBlue};
      }
    }
  }
  

.missMatchModal {
  .modal-dialog {
    max-width: 468px;
    .modal-content .modal-body {
      padding: 32px 28px 40px;
    }
    .modal-content .modal-footer {
      padding: 0px 28px 28px;      
    }
  }

  .customWidth {
    width: 80%;
    margin: 0 auto;
  }

  .btn-secondary.missMatchModalOuter {
    border-radius: 8px;
    height: 52px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.blue.dark};
    background-color: ${(props) => props.theme.color.white};
    color: ${(props) => props.theme.blue.dark};
    font-size: 17px;
    line-height: 21px;
    font-weight: 700;
  }
}

.beforeAddressChangeModal{
  &.padding {
    .modal-content{
      padding-bottom: 20px;
    }
  }
  .btn-primary{
    &.homecare{
      background: transparent !important;
      margin:4px 0 !important;
      color: ${(props) => props?.theme?.blue?.royal} !important;
    }
  }
  .itemCount{
    font-weight: 600;
    font-size: 15px;
    line-height: 19px;
  }
  .serviceList{
    overflow:auto;
    max-height: 210px;
    padding:0 28px;

    .serviceItem{
      display:flex;
      padding:16px;
      gap:20px;
      align-items:center;
      font-weight: 700;
      font-size: 15px;
      line-height: 21px;
      border: 1px solid ${(props) => props.theme.color.borderLight};;
      border-radius: 8px;
      margin-bottom:12px;

      .serviceImage{
        min-width: 72px;
        min-height:60px;
        overflow:hidden;
        border-radius: 8px;

        > div{
           display:block !important;
        }
      }
    }
  }
  .modalDialogStyled{
    .modal-content{
      .modal-header {
        padding: 24px;
        .modal-title {
          width: 100%;
          font-size: 20px;
          font-weight: 700;
          text-align: center;

          &.text-left {
            text-align: left;
          }
        }
      }
      .modal-body{
        padding:0;
      }
      .modal-footer{
        padding: 0 28px 12px;
      }
    }
  }  
}

  @media (max-width: 820px) {
    .noDesktop {
      display: none !important;
    }
    .noTablet {
      display: none !important;
    }

    .container {
      padding: 0 16px;
    }
    
    .pageContent {
      padding-top: ${(props) => (props?.isNotSafari ? '316px' : '162px')} !important;
    }
  }

  @media (max-width: 767px) {
    .pageContent {
      padding-top: ${(props) => (props?.isNotSafari ? (props?.isDisallowedSwitcher ? '274px' : '316px') : (props?.isDisallowedSwitcher ? '120px' : '162px'))} !important;
    }
  }

  @media (max-width: 576px) {
    .noMobile {
      display: none !important;
    }


    .tooltip {
      z-index: 1200;
      left: auto !important;
   
      .tooltip-arrow {
        left: auto !important;
      }
  
      .tooltip-inner {
        min-width: 280px;
      }
    }
  }

  @media (max-width: 480px) {
    .add_insurance_modal {
      .insuranceProfile {
        border-bottom : 0px;
      }
      .insurance-method {
        background: none;

        .tab-wrapper {
          margin-top: 0px;
        }

        .checkoutbox-insurance {
          margin-top: 40px;
        }

        .checkoutbox-emirates {
          margin-top: 95px;
        }

        .checkoutbox-wrapper {
          .add-insurance-checkbox-wrapper {
            .add-insurance-checkbox {
              .form-check {
                .form-check-input[type='checkbox'] {
                  margin-top: 12px;
                }
              }
            }
          }
        } 
      }
      .date-picker-emirates {
        margin-top: 12px;
      } 
    }

    .video-player {
      .modal-dialog {
        .modal-content, .modal-header {
          background: transparent !important;
          border: none !important;
          .modal-header .modal-title {
            font-size: 12px !important;
          }
          .modal-body {
            padding: 24px 12px;
            iframe {
              padding: 0;
              width: 100%;
              height: 250px;
            }
          }
        }
      } 
    }

    iframe {
      height: calc(100vh - 180px);
      padding:0 15px;
    }
    .pageContent {
      padding-top: ${(props) => (props?.isNotSafari ? (props?.isDisallowedSwitcher ? '222px' : '264px') : (props?.isDisallowedSwitcher ? '121px' : '163px'))} !important;
    }
    .orderTrackPopUp{
      iframe {
        height: 500px;
        padding:0;
        max-width: 100%;
      }
    }
    .orderTrackDetails {
      &.map{
      padding-top:100px;
       }
     }
    }
    .modal {
      &.modalVideoCall {
        opacity: 1;
          .modalDialogStyled {
          .modal-footer {
            flex-direction: column;

            .btn {
              width: 100%;

              &.btn-secondary {
                margin-right: 0;
                margin-bottom: 16px;
              }
            }
          }  
        }
      }
    }

    .page_PDP {
      .pageContent {
        .breadcrumb {
          .breadcrumb-item {
            a,
            &.active {
              font-size: 12px;
            }
          }
        }
        .tostControl {
          .newVariantGreen {
            &.floating-wrapper {
              top: 80px;
            }
          }
        }
        .productDetailWrapper {
          .productShowcaseWrapper {
            min-height: 200px;

            .slick-dots {
              bottom: -20px;
            }
          }
          .productDetailInfo {
            .order-wrapper {
              .priceWrapper {
                .price{
                  font-size: 18px;
                }
              }
            }
          }

          .productInfoWrapper {
            .brandName {
              font-size: 14px;
              line-height: 18px;
              margin: 10px 0 5px 0;
            }

            .productName {
              font-size: 16px;
              line-height: 20px;
            }

            .priceContainer {
              margin-top: 10px;
              margin-bottom: 14px;

              .priceWrapper {
                .price {
                  font-size: 16px;
                  line-height: 16px;
                }
                .tax {
                  font-size: 12px;
                }
              }
              .points-wrapper {
                margin-top: 2px;
              }
            }
            .delivery-detail {
              .delivery-time {
                font-size: 13px;
                line-height: 15px;
              }
            }
            .bankOffersBox {
              .offersBox {
                padding-bottom: 12px;

                .description {
                  margin-left: 8px;
                  .text {
                    font-size: 12px;
                    line-height: 14px;
                  }
                  .showHide {
                    font-size: 12px;
                    line-height: 14px;
                  }
                }
              }
              .moreOffers {
                font-size: 12px;
                padding-top: 10px;
              }
            }
            .uspBox {
              .usp {
                .name {
                  font-size: 12px;
                }
                &:first-child {
                  .name {
                    max-width: 80px;
                  }
                }
                &:last-child {
                  .name {
                    max-width: 80px;
                  }
                }
              }
            }
          }
        }

        .productSliderMobileWrapper {
          .slick-list {
            .slick-track {
              .categoryItemBox {
                .item-wrapper {
                  height: 200px;
                }
              }
            }
          }
        }

        .information-wrapper {
          padding: 16px;

          .overviewItems {
            margin-bottom: 10px;

            h2 {
              font-size: 13px;
            }
            .detailsBox {
              font-size: 12px;

              ul {
                margin-bottom: 10px;
              }
            }
          }
        }

        .specificationsBox {
          .specs {
            padding: 16px;

            .specRow {
              .labelText {
                font-size: 12px;
              }
              .valueText {
                font-size: 12px;
              }
            }
          }

          .legalDisclaimerClick {
            padding: 12px 16px;

            .ic {
              max-width: 18px;
              max-height: 18px;
            }

            .text {
              font-size: 13px;
            }
          }
        }

        .showSpecs {
          font-size: 14px;
        }
      }

      .page_pdp_hereToHelp {
        .text {
          font-size: 16px;
          margin-bottom: 10px;
        }
      }

      .page_pdp_footer {
        .topArea {
          padding: 15px 0;

          .container {
            margin-bottom: 0;
          }

          .leftArea {
            margin: 0 0 10px 0;

            .footer-label-text {
              font-size: 14px;
            }
          }

          .rightArea {
            .sectionArea {
              margin: 0 0 10px 0;
              .title {
                font-size: 14px;
                margin: 0 0 5px 0;
                padding: 0 0 5px 0;
              }
              ul {
                li {
                  margin: 0 0 5px 0;
                }
                &.social {
                  margin-top: 5px;
                  li {
                    margin: 0 8px 5px 0;
                  }
                }
              }
            }
            .storeLink {
              margin-top: 15px;
            }
          }
        }

        .bottomArea {
          .container {
            .links {
              margin: 0 0 10px 0;
            }
          }
        }
      }
    }

    @media only screen and (max-width: 574px) {
      .searchPageHeader {
        &.fixed {
          .container {
            .content {
              min-height: 1px;
              opacity: 0;
              position: relative;
              transition: 0.4s linear min-height;
              > * {
                position: absolute;
              }
            }
            .mobileSearchBox {
              margin-top: 0;
            }
          }
        }
      }
    }
  }

.font-17{
  font-size: 17px;
  line-height: 21px;
  font-weight: 500;
}

.selectExistingProfileModal {
 .rightBarDialogStyled {
    .modal-body {
      padding-bottom: 100px !important;

      select:disabled {
        opacity: 0.5;
      }
    }

    .modal-footer {
      flex-direction: column;
      height: auto !important;

      button:last-child {
        text-decoration: none;
        font-size: 15px;
        font-weight: 700;
        color: ${(props) => props.theme.blue.dark};
      }
    }
  }
}

.homecare-modal-msg{
  font-weight : 400;
}

.product-review-modal{
  .rightBarDialogStyled {
    .modal-content {

      .product-rating-wrapper {
        padding:24px;
          .card_wrapper {
            p.title{
              font-size: 20px;
            }
            p.subtitle {
              margin: 6px auto;
            }
          }
          .invalid-feedback {
            font-size: 16px;
          }
        .productInfo {
          width: 100%;
          border-bottom: 1px solid ${(props) => props?.theme?.color?.border};
          margin-bottom: 24px;
          padding-bottom: 24px;
          display: flex;
          flex-direction: row;
          align-items: center;

          .productPic {
            min-width: 70px;
            width: 70px;
            height: 70px;
            border: 1px solid ${(props) => props?.theme?.color?.border};
            border-radius: 8px;
            margin-right: 16px;
            overflow: hidden;
          }
          .productName {
            font-size: 18px;
            line-height: 23px;
            font-weight: 600;
          }
        }

        .spaceHolder {
          .card_wrapper {
            background: transparent;  
            padding: 90px 15px 110px;
          }
        }
      }

      .form-label {
        font-size: 17px;
        font-weight: 700;
      }

      .form-floating {
        .form-label {
          font-size: 16px;
          font-weight: 400 !important;
          color: ${(props) => props?.theme?.text?.medium} !important;
        }

        textarea {  
          height: 46px !important;
        }
      }

    
    }
  }
}

.pdp-mobile-btm-spacing {
  padding-bottom: 80px;
  .bottomArea .goToTop.show {
    bottom: 55px;
    }
  }
  @media (max-width: 820px) {
    .pdp-mobile-btm-spacing {
    
      .bottomArea .goToTop.show {
      bottom: 100px;
      }
    }
  }
  .out-of-stock-modal .rightBarDialogStyled{
    .modal-content{
        .modal-body {
          font-size: 16px;
          padding: 24px 24px 0;
        } 
      .stock-body{
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        margin-bottom:24px;
      }
      .stock-image-card{
        display: flex;
        background:  ${(props) => props.theme.color.white};
        align-items: center;
        border: 1px solid ${(props) => props.theme.color.lightGray};
        box-sizing: border-box;
        border-radius: 8px;
        padding: 16px;
        margin-top: 12px;
        .image-wrapper{
          width: 70px;
          height: 70px;
          border: 1px solid ${(props) => props.theme.color.lightGray};
          box-sizing: border-box;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          margin-right: 16px;
        }
      }
      .btn-primary {
        color: ${(props) => props.theme.color.white};
        font-weight: 700;
        background:${(props) => props.theme.green.dark};
        border-color: ${(props) => props.theme.green.dark};
        margin-right: 0;
      }
    }
  }
  .merge-cart-section{
    .modalDialogStyled{
      .modal-content{
        .modal-body {
          font-weight:400;
          padding: 16px 24px;
        }
        .modal-footer{
          padding:0 16px;
          
        }
      }
    }
  }
  .merge-cart-btn{
    margin-top: 16px;
  }
  .merge-cart-btn-cancel{
    margin: 0 0px 0 0;
    color: ${(props) => props.theme.text.dark};
    text-decoration: none;
    &:hover{
      color: ${(props) => props.theme.text.dark};
    }
  }
.font-17-reg{
  font-size: 17px;
  line-height: 21px;
  font-weight: normal;
  color: ${(props) => props.theme.color.icon};
}
.font-mandate-email-reg {
  font-size: 17px;
  line-height: 21px;
  font-weight: 600;
  color: ${(props) => props.theme.color.icon};
}
.card {
  border-color: ${(props) => props.theme.color.lightGray};
  border-radius : 8px;
}
.list-group{
  border-color: ${(props) => props.theme.color.lightGray};
  border-radius : 8px;
  .list-group-item{
     &:last-child{
      border-bottom-left-radius : 8px;
      border-bottom-right-radius : 8px;
     }
  }
}
.mobile-d-none {
  display: block;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}

.no-transform{
  text-transform: none!important;
}

.avtarName{
  overflow: hidden;
  background: ${(props) => props.theme.blue.grey};
  color: ${(props) => props.theme.color.white};
  font-size: 15px;
  text-align: center;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height:normal;

  &.ins-rsb {
    width: 50px;
    height: 50px;
  }
}

.bold-text {
  font-weight: bold;
  font-size: 16px;
}

.disclaimer-wrapper {
  background: ${(props) => props.theme.yellow.off};
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 22px;

  .disclaimer {
    font-weight: 600;
  }
}

.blue-text {
  font-weight: bold;
  font-size: 16px;
  color: ${(props) => props.theme.blue.dark};
  cursor: pointer;
}

hr{
  border-color: ${(props) => props.theme.color.borderLight};

}

@media (max-width: 820px) {
  .pageContent {
    &.no-scroll{
      position:fixed;
      top:0;
      bottom:0;
      left:0; 
      right:0;
      height:100%;
      max-height:100%;
      overflow:hidden;
    }
    &.no-scroll-desktop{
      max-height:100vh;
      overflow:hidden;
    }
  }  
  .mobile-d-none {
    display: none;
  }

  .noDesktop {
    display:flex !important;
  }

  .btn {
    &.btn-primary {
      &.button-container{
        &:hover {
          background: ${(props) => props?.theme?.blue?.dark};
          border-color: ${(props) => props?.theme?.blue?.dark};  
        }
      }
    }  
  }
  .px-xs-2{
    padding-right: 1rem !important; 
    padding-left: 1rem !important;  
  }
}

 @media (max-width: 575px) {
  .button-hover-none{
    .modalDialogStyled{
      .modal-content{
        .modal-footer{
          .btn-primary{
            &:hover {
              background: ${(props) => props?.theme?.blue?.dark};
              border-color:  ${(props) => props?.theme?.blue?.dark}; 
            }
          }
          .btn-secondary{
            &:hover {
              color:${(props) => props?.theme?.blue?.dark};
              background: ${(props) => props?.theme?.blue?.off};
              border-color:  ${(props) => props?.theme?.blue?.off}; 
            }
          }
        }
      }
    }
  }
}

.newAvatar {
  min-width: 49px;
  min-height: 49px;
  margin-right: 13px;
}

@media (max-width: 380px) {
  .pageContent {
    padding-top: ${(props) => (props?.isNotSafari ? (props?.isDisallowedSwitcher ? '206px' : '248px') : (props?.isDisallowedSwitcher ? '120px' : '162px'))} !important;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@supports (-webkit-overflow-scrolling: touch) {
  input,textarea,select {
    font-size:16px !important;
  }
}
.profileMsg {
  span {
    margin-top: -17px;
  }
}
.grey-contact-text {
  color: ${(props) => props.theme.text.medium};
  font-weight: 600;
}
.blue-contact-text {
  color: ${(props) => props.theme.blue.dark};
  font-weight: 600;
}

.packageCancelReasons {
  .rightBarDialogStyled {
    .right-side-cancel-policy {
        .cancel-refund-title {
          display: flex;
          justify-content: center;
          align-items: end;
          p {
            color: ${({ theme }) => theme?.text?.medium};
            font-size: 14px;
            line-height: 18px;
            margin-bottom: 0;
          }
          .green-text {
            text-decoration: none;
            color: ${({ theme }) => theme?.blue?.dark};
            font-size: 14px;
            line-height: 18px;
          }
        }
      }

      .cancellationReason  {
        height: calc(100% - 30px);
        overflow: auto;
      }
    .cancellationReason .opt {
      padding: 15px 0;
     } 
    }
    .cancelDescription {
      color: ${({ theme }) => theme?.royalBlue?.DarkBlueGray};
      font-size: 15px;
      line-height: 19px;
      margin-bottom:10px;
    }
    .modal-content {
      .form-check {
        align-items:center;
        .form-check-label {
          color: ${({ theme }) => theme?.text?.dark};
          font-size: 16px;
          font-weight: 600;
          line-height: 20px;
        }
        .form-check-input[type="radio"] {
          margin:0 10px 0 0;
          &:checked {
            background: url(${IC_RADIO_CHECKED.src}) no-repeat 50% 50%;
            + label {
              color: ${(props) => props?.theme?.blue?.dark}
            }
          }
        }
      }
    }
    .rr {
      border-bottom: 1px solid ${({ theme }) => theme?.color?.borderLight};
      &:last-child {
      border-bottom: 0 !important;
      }
    }
  }
  .npsFeedbackModal{
    position : fixed;
    &.modal {
      .modalDialogStyled {
        .modal-content {
          .modal-body {
            padding: 0;
            .modalBody{
              max-height: 85vh;
              height: auto;
              overflow: auto;
            }
          }

          @media(max-width:576px){
            margin-bottom:40px;
          }
        }
      }
    }
    .modal-dialog {
      margin: 2rem 22px 3.15vh auto;
      max-width: 459px;
      align-items: flex-end;
      // display: flex;

      @media(max-width:576px){
        margin: 2rem 15px 4vh auto;
        width:100%;
        max-width: 100%;
        padding:0 15px;
      }
  }
  }
  @media (max-width: 420px) {
  .modal{
   .rightBarDialogStyled {
    .modal-content {
      .modal-header {
        .modal-title{
         font-size: 19px;
        }
      }
    }
  }
 }
 }
 @media (max-width: 430px) {
 .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .cardswrapper {
    padding-left: 14px !important;
 }
  .rxupload_disclaimer_product {
 }
}


@media (max-width: 414px) {
 .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .cardswrapper {
    padding-left: 14px !important;
 }
 .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .bundlecard {
    width: 386px !important;
  }
  .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .bundlecardgreen:hover {
    width: 386px !important;
 }
 .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .bundlecardgreen .imageicon {
  margin-left: 334px !important;
}
}

@media (max-width: 390px) {
 .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .cardswrapper {
    padding-left: 14px !important;
 }
 .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .bundlecard {
    width: 366px !important;
  }
  .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .bundlecardgreen:hover {
    width: 366px !important;
 }
 .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .bundlecardgreen .imageicon {
  margin-left: 317px !important;
}
}

@media (max-width: 375px) {
 .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .cardswrapper {
    padding-left: 12px !important;
 }
 .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .bundlecard {
    width: 348px !important;
  }
  .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .bundlecardgreen:hover {
    width: 348px !important;
 }
 .modal .rightBarDialogStyled .modal-content .modal-body.bundleOfferBody .bundlecardgreen .imageicon {
  margin-left: 306px !important;
}
}
.modal-wrapper-leaflet {
 .modal-dialog {
  .modal-content{
  .modal-footer {
    padding: 25px 16px 0px 16px;
  }
    .modal-body {
      .brandNameProductNameInner {
        .brandName {
          color: ${(props) => props.theme.green.dark};
          font-size: 14px;
          font-weight: 700;
          line-height: 18px;
          margin: 0 0 4px 0;

          a {
            text-decoration: none;
            color: ${(props) => props.theme.green.dark};

            &:hover {
              text-decoration: underline;
            }
          }
        }       
      }
      .ePharmacy {
        .link {
          color: ${(props) => props.theme.green.darkGreen};
        }
      }
    }
  }
  }
}

.rightBarDialogStyled {
  &.rtl {
    .modal-content {
      .modal-header {
        .btn-close {
          &:before {
            left: 0px;
            right: -22px;
          }
          &:after {
            left: 0px;
            right: -22px;
          }
        }
        .modal-title {
          width: 100%;
        }
      }
    }
  }
}

`;
